import React from "react";

export const SVG_DELETE_ICON = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8362 2.0148H9.9234V1.53988C9.9234 0.690789 9.23261 0 8.38351 0H5.6146C4.7655 0 4.07471 0.690789 4.07471 1.53988V2.0148H1.16188C0.946013 2.0148 0.773315 2.1875 0.773315 2.40337C0.773315 2.61924 0.946013 2.79194 1.16188 2.79194H1.86419V11.9219C1.86419 13.0674 2.79675 14 3.94231 14H10.0558C11.2014 14 12.1339 13.0674 12.1339 11.9219V2.79194H12.8362C13.0521 2.79194 13.2248 2.61924 13.2248 2.40337C13.2248 2.1875 13.0521 2.0148 12.8362 2.0148ZM4.85185 1.53988C4.85185 1.11965 5.19437 0.777138 5.6146 0.777138H8.38351C8.80374 0.777138 9.14626 1.11965 9.14626 1.53988V2.0148H4.85185V1.53988ZM11.3568 11.9219C11.3568 12.6386 10.7725 13.2229 10.0558 13.2229H3.94231C3.22562 13.2229 2.64133 12.6386 2.64133 11.9219V2.79194H11.3597V11.9219H11.3568Z"
      fill="#FE3745"
    />
    <path
      d="M6.9991 11.8298C7.21496 11.8298 7.38766 11.6571 7.38766 11.4412V4.57363C7.38766 4.35776 7.21496 4.18506 6.9991 4.18506C6.78323 4.18506 6.61053 4.35776 6.61053 4.57363V11.4383C6.61053 11.6542 6.78323 11.8298 6.9991 11.8298Z"
      fill="#FE3745"
    />
    <path
      d="M4.46395 11.401C4.67982 11.401 4.85252 11.2283 4.85252 11.0124V4.99965C4.85252 4.78378 4.67982 4.61108 4.46395 4.61108C4.24808 4.61108 4.07538 4.78378 4.07538 4.99965V11.0124C4.07538 11.2283 4.25095 11.401 4.46395 11.401Z"
      fill="#FE3745"
    />
    <path
      d="M9.53524 11.401C9.75111 11.401 9.9238 11.2283 9.9238 11.0124V4.99965C9.9238 4.78378 9.75111 4.61108 9.53524 4.61108C9.31936 4.61108 9.14667 4.78378 9.14667 4.99965V11.0124C9.14667 11.2283 9.31936 11.401 9.53524 11.401Z"
      fill="#FE3745"
    />
  </svg>
);

export const SVG_TRASH_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.33301 4C1.33301 3.63181 1.63148 3.33333 1.99967 3.33333H13.9997C14.3679 3.33333 14.6663 3.63181 14.6663 4C14.6663 4.36819 14.3679 4.66667 13.9997 4.66667H1.99967C1.63148 4.66667 1.33301 4.36819 1.33301 4Z"
      fill="#EB5757"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66699 2C6.49018 2 6.32061 2.07024 6.19559 2.19526C6.07056 2.32029 6.00033 2.48986 6.00033 2.66667V4C6.00033 4.36819 5.70185 4.66667 5.33366 4.66667C4.96547 4.66667 4.66699 4.36819 4.66699 4V2.66667C4.66699 2.13623 4.87771 1.62752 5.25278 1.25245C5.62785 0.87738 6.13656 0.666666 6.66699 0.666666H9.33366C9.86409 0.666666 10.3728 0.87738 10.7479 1.25245C11.1229 1.62752 11.3337 2.13623 11.3337 2.66667V4C11.3337 4.36819 11.0352 4.66667 10.667 4.66667C10.2988 4.66667 10.0003 4.36819 10.0003 4V2.66667C10.0003 2.48986 9.93009 2.32029 9.80506 2.19526C9.68004 2.07024 9.51047 2 9.33366 2H6.66699ZM3.33366 3.33333C3.70185 3.33333 4.00033 3.63181 4.00033 4V13.3333C4.00033 13.5101 4.07056 13.6797 4.19559 13.8047C4.32061 13.9298 4.49018 14 4.66699 14H11.3337C11.5105 14 11.68 13.9298 11.8051 13.8047C11.9301 13.6797 12.0003 13.5101 12.0003 13.3333V4C12.0003 3.63181 12.2988 3.33333 12.667 3.33333C13.0352 3.33333 13.3337 3.63181 13.3337 4V13.3333C13.3337 13.8638 13.1229 14.3725 12.7479 14.7475C12.3728 15.1226 11.8641 15.3333 11.3337 15.3333H4.66699C4.13656 15.3333 3.62785 15.1226 3.25278 14.7475C2.87771 14.3725 2.66699 13.8638 2.66699 13.3333V4C2.66699 3.63181 2.96547 3.33333 3.33366 3.33333Z"
      fill="#EB5757"
    />
  </svg>
);

export const SVG_EDIT_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.9641 1.03649C13.5868 -0.344196 11.347 -0.344196 9.96977 1.03649L0.812902 10.19C0.741311 10.2615 0.696993 10.3536 0.683356 10.4525L0.0049436 15.4775C-0.015511 15.6207 0.0356256 15.7639 0.13449 15.8627C0.219717 15.9479 0.339036 15.9991 0.458355 15.9991C0.47881 15.9991 0.499264 15.9991 0.519719 15.9957L3.54701 15.5866C3.79928 15.5525 3.97655 15.3207 3.94246 15.0684C3.90837 14.8161 3.67655 14.6388 3.42428 14.6729L0.996994 15.0002L1.47086 11.4956L5.15951 15.1843C5.24474 15.2695 5.36406 15.3207 5.48338 15.3207C5.6027 15.3207 5.72202 15.2729 5.80725 15.1843L14.9641 6.03084C15.6323 5.36266 16.0005 4.47629 16.0005 3.53196C16.0005 2.58764 15.6323 1.70127 14.9641 1.03649ZM10.147 2.1615L11.6845 3.69901L3.32882 12.0547L1.79132 10.5172L10.147 2.1615ZM5.48679 14.2093L3.98337 12.7059L12.3391 4.35015L13.8425 5.85357L5.48679 14.2093ZM14.4834 5.19561L10.805 1.51718C11.272 1.13195 11.855 0.920584 12.4686 0.920584C13.1675 0.920584 13.8221 1.19331 14.3164 1.68423C14.8107 2.17514 15.08 2.8331 15.08 3.53196C15.08 4.14901 14.8687 4.72856 14.4834 5.19561Z" />
  </svg>
);

export const SVG_EDIT_PENCIL_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_203_10294)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.667 2.11438C12.5069 2.11438 12.3484 2.14591 12.2005 2.20717C12.0526 2.26843 11.9183 2.35821 11.8051 2.4714L2.93027 11.3462L2.28382 13.7165L4.65412 13.0701L13.5289 4.19526C13.6421 4.08207 13.7319 3.94769 13.7932 3.79981C13.8544 3.65192 13.886 3.49341 13.886 3.33333C13.886 3.17326 13.8544 3.01475 13.7932 2.86686C13.7319 2.71897 13.6421 2.58459 13.5289 2.4714C13.4157 2.35821 13.2814 2.26843 13.1335 2.20717C12.9856 2.14591 12.8271 2.11438 12.667 2.11438ZM11.6903 0.975329C11.9999 0.847064 12.3318 0.781048 12.667 0.781048C13.0022 0.781048 13.3341 0.847064 13.6437 0.975329C13.9534 1.10359 14.2347 1.29159 14.4717 1.52859C14.7087 1.7656 14.8967 2.04696 15.025 2.35662C15.1533 2.66627 15.2193 2.99816 15.2193 3.33333C15.2193 3.6685 15.1533 4.00039 15.025 4.31005C14.8967 4.61971 14.7087 4.90107 14.4717 5.13807L5.47175 14.1381C5.38971 14.2201 5.28768 14.2793 5.17575 14.3098L1.50909 15.3098C1.27828 15.3728 1.03144 15.3072 0.86227 15.1381C0.693103 14.9689 0.627551 14.7221 0.690498 14.4913L1.6905 10.8246C1.72102 10.7127 1.78023 10.6106 1.86227 10.5286L10.8623 1.52859C11.0993 1.29159 11.3806 1.10359 11.6903 0.975329Z"
        fill="#18A0FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_203_10294">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_DUPLICATE_ICON = (
  <svg
    width="14"
    height="20"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.2966 2.79834H1.85855C1.16061 2.79834 0.59375 3.3652 0.59375 4.06314V14.7353C0.59375 15.4332 1.16061 16.0001 1.85855 16.0001H9.2966C9.99453 16.0001 10.5614 15.4332 10.5614 14.7353V4.06314C10.5581 3.3652 9.99125 2.79834 9.2966 2.79834ZM9.67342 14.732C9.67342 14.9417 9.50303 15.1121 9.29332 15.1121H1.85527C1.64556 15.1121 1.47518 14.9417 1.47518 14.732V4.06314C1.47518 3.85343 1.64556 3.68304 1.85527 3.68304H9.29332C9.50303 3.68304 9.67342 3.85343 9.67342 4.06314V14.732Z" />
    <path d="M12.1403 0H4.7023C4.00436 0 3.4375 0.566865 3.4375 1.2648C3.4375 1.51055 3.6341 1.70715 3.87985 1.70715C4.1256 1.70715 4.3222 1.51055 4.3222 1.2648C4.3222 1.05509 4.49259 0.884702 4.7023 0.884702H12.1403C12.3501 0.884702 12.5204 1.05509 12.5204 1.2648V11.9369C12.5204 12.1466 12.3501 12.317 12.1403 12.317C11.8946 12.317 11.698 12.5136 11.698 12.7594C11.698 13.0051 11.8946 13.2017 12.1403 13.2017C12.8383 13.2017 13.4051 12.6349 13.4051 11.9369V1.2648C13.4051 0.566865 12.8383 0 12.1403 0Z" />
  </svg>
);

export const SVG_DUPLICATE_USER_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_203_10489)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.33301 6.66634C6.96482 6.66634 6.66634 6.96482 6.66634 7.33301V13.333C6.66634 13.7012 6.96482 13.9997 7.33301 13.9997H13.333C13.7012 13.9997 13.9997 13.7012 13.9997 13.333V7.33301C13.9997 6.96482 13.7012 6.66634 13.333 6.66634H7.33301ZM5.33301 7.33301C5.33301 6.22844 6.22844 5.33301 7.33301 5.33301H13.333C14.4376 5.33301 15.333 6.22844 15.333 7.33301V13.333C15.333 14.4376 14.4376 15.333 13.333 15.333H7.33301C6.22844 15.333 5.33301 14.4376 5.33301 13.333V7.33301Z"
        fill="#18A0FB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.66699 2.00033C2.49018 2.00033 2.32061 2.07056 2.19559 2.19559C2.07056 2.32061 2.00033 2.49018 2.00033 2.66699V8.66699C2.00033 8.8438 2.07056 9.01337 2.19559 9.1384C2.32061 9.26342 2.49018 9.33366 2.66699 9.33366H3.33366C3.70185 9.33366 4.00033 9.63214 4.00033 10.0003C4.00033 10.3685 3.70185 10.667 3.33366 10.667H2.66699C2.13656 10.667 1.62785 10.4563 1.25278 10.0812C0.877706 9.70613 0.666992 9.19743 0.666992 8.66699V2.66699C0.666992 2.13656 0.877706 1.62785 1.25278 1.25278C1.62785 0.877706 2.13656 0.666992 2.66699 0.666992H8.66699C9.19743 0.666992 9.70613 0.877706 10.0812 1.25278C10.4563 1.62785 10.667 2.13656 10.667 2.66699V3.33366C10.667 3.70185 10.3685 4.00033 10.0003 4.00033C9.63214 4.00033 9.33366 3.70185 9.33366 3.33366V2.66699C9.33366 2.49018 9.26342 2.32061 9.1384 2.19559C9.01337 2.07056 8.8438 2.00033 8.66699 2.00033H2.66699Z"
        fill="#18A0FB"
      />
    </g>
    <defs>
      <clipPath id="clip0_203_10489">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_STOP_ICON = (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="11" height="11" rx="2" />
  </svg>
);

export const SVG_PLAY_ICON = (
  <svg
    width="21"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.1427 10.8436C16.4941 11.0254 16.5052 11.524 16.1622 11.7212L5.2492 17.9949C4.91587 18.1866 4.5 17.946 4.5 17.5615L4.5 5.64309C4.5 5.2684 4.89691 5.02684 5.22971 5.19898L16.1427 10.8436Z" />
  </svg>
);

export const SVG_SHARE_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 1.99935C11.2636 1.99935 10.6667 2.5963 10.6667 3.33268C10.6667 4.06906 11.2636 4.66602 12 4.66602C12.7364 4.66602 13.3333 4.06906 13.3333 3.33268C13.3333 2.5963 12.7364 1.99935 12 1.99935ZM9.33334 3.33268C9.33334 1.85992 10.5272 0.666016 12 0.666016C13.4728 0.666016 14.6667 1.85992 14.6667 3.33268C14.6667 4.80544 13.4728 5.99935 12 5.99935C10.5272 5.99935 9.33334 4.80544 9.33334 3.33268Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 6.66732C3.26362 6.66732 2.66667 7.26427 2.66667 8.00065C2.66667 8.73703 3.26362 9.33398 4 9.33398C4.73638 9.33398 5.33334 8.73703 5.33334 8.00065C5.33334 7.26427 4.73638 6.66732 4 6.66732ZM1.33334 8.00065C1.33334 6.52789 2.52724 5.33398 4 5.33398C5.47276 5.33398 6.66667 6.52789 6.66667 8.00065C6.66667 9.47341 5.47276 10.6673 4 10.6673C2.52724 10.6673 1.33334 9.47341 1.33334 8.00065Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 11.3333C11.2636 11.3333 10.6667 11.9303 10.6667 12.6667C10.6667 13.403 11.2636 14 12 14C12.7364 14 13.3333 13.403 13.3333 12.6667C13.3333 11.9303 12.7364 11.3333 12 11.3333ZM9.33334 12.6667C9.33334 11.1939 10.5272 10 12 10C13.4728 10 14.6667 11.1939 14.6667 12.6667C14.6667 14.1394 13.4728 15.3333 12 15.3333C10.5272 15.3333 9.33334 14.1394 9.33334 12.6667Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.15066 8.67097C5.33604 8.35285 5.7442 8.24524 6.06232 8.43061L10.6157 11.0839C10.9338 11.2693 11.0414 11.6775 10.856 11.9956C10.6706 12.3137 10.2625 12.4213 9.94435 12.236L5.39101 9.58262C5.0729 9.39725 4.96529 8.98909 5.15066 8.67097Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8491 4.00458C11.0347 4.32259 10.9274 4.73082 10.6094 4.91639L6.06268 7.56973C5.74468 7.75531 5.33645 7.64796 5.15087 7.32996C4.9653 7.01195 5.07265 6.60372 5.39065 6.41814L9.93731 3.76481C10.2553 3.57923 10.6635 3.68658 10.8491 4.00458Z"
      fill="#18A0FB"
    />
  </svg>
);
export const SVG_COPY_ICON = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_59743_71665)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.5 5C5.22386 5 5 5.22386 5 5.5V10C5 10.2761 5.22386 10.5 5.5 10.5H10C10.2761 10.5 10.5 10.2761 10.5 10V5.5C10.5 5.22386 10.2761 5 10 5H5.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4H10C10.8284 4 11.5 4.67157 11.5 5.5V10C11.5 10.8284 10.8284 11.5 10 11.5H5.5C4.67157 11.5 4 10.8284 4 10V5.5Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 1.5C1.86739 1.5 1.74021 1.55268 1.64645 1.64645C1.55268 1.74021 1.5 1.86739 1.5 2V6.5C1.5 6.63261 1.55268 6.75979 1.64645 6.85355C1.74021 6.94732 1.86739 7 2 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H2C1.60217 8 1.22064 7.84196 0.93934 7.56066C0.658035 7.27936 0.5 6.89782 0.5 6.5V2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H6.5C6.89782 0.5 7.27936 0.658035 7.56066 0.93934C7.84196 1.22064 8 1.60217 8 2V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V2C7 1.86739 6.94732 1.74021 6.85355 1.64645C6.75979 1.55268 6.63261 1.5 6.5 1.5H2Z"
        fill="#6D7F92"
      />
    </g>
    <defs>
      <clipPath id="clip0_59743_71665">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_STATS_ICON = (
  <svg
    width="16"
    height="8"
    viewBox="0 0 16 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.3011 0.208772C13.3644 0.208772 12.6023 0.970864 12.6023 1.90761C12.6023 2.24927 12.704 2.56742 12.8783 2.83408L11.0429 4.66948C10.7762 4.49523 10.458 4.39351 10.1164 4.39351C9.76233 4.39351 9.4333 4.50251 9.16086 4.68854L7.30655 2.83395C7.48077 2.5673 7.58242 2.24917 7.58242 1.90758C7.58242 0.970833 6.82033 0.20874 5.88358 0.20874C4.94683 0.20874 4.18474 0.970833 4.18474 1.90758C4.18474 2.24917 4.28643 2.5672 4.46059 2.83386L2.62512 4.66936C2.3585 4.49517 2.0404 4.39351 1.69884 4.39351C0.762092 4.39351 0 5.15564 0 6.09239C0 7.02913 0.762092 7.79123 1.69884 7.79123C2.63559 7.79123 3.39768 7.02913 3.39768 6.09239C3.39768 5.75073 3.29596 5.43257 3.12171 5.16589L4.95712 3.33048C5.2238 3.50473 5.54196 3.60645 5.88361 3.60645C6.22524 3.60645 6.54339 3.50473 6.81005 3.33048L8.67461 5.19529C8.51192 5.45586 8.41755 5.76323 8.41755 6.09235C8.41755 7.0291 9.17964 7.79119 10.1164 7.79119C11.0531 7.79119 11.8152 7.0291 11.8152 6.09235C11.8152 5.75076 11.7135 5.4327 11.5394 5.16607L13.3749 3.33058C13.6415 3.50477 13.9596 3.60642 14.3012 3.60642C15.2379 3.60642 16 2.84433 16 1.90758C16 0.970801 15.2379 0.208772 14.3011 0.208772ZM1.69884 7.08901C1.14928 7.08901 0.702186 6.64192 0.702186 6.09239C0.702186 5.54282 1.14928 5.09573 1.69884 5.09573C2.24837 5.09573 2.69549 5.54282 2.69549 6.09239C2.69549 6.64192 2.2484 7.08901 1.69884 7.08901ZM5.88361 2.90424C5.33408 2.90424 4.88696 2.45714 4.88696 1.90758C4.88696 1.35805 5.33405 0.910926 5.88361 0.910926C6.43318 0.910926 6.88027 1.35802 6.88027 1.90758C6.88027 2.45714 6.43318 2.90424 5.88361 2.90424ZM10.1164 7.08901C9.56683 7.08901 9.1197 6.64192 9.1197 6.09235C9.1197 5.54279 9.56679 5.0957 10.1164 5.0957C10.6659 5.0957 11.113 5.54279 11.113 6.09235C11.113 6.64192 10.6659 7.08901 10.1164 7.08901ZM14.3011 2.90424C13.7516 2.90424 13.3045 2.45714 13.3045 1.90758C13.3045 1.35805 13.7516 0.910926 14.3011 0.910926C14.8507 0.910926 15.2978 1.35802 15.2978 1.90758C15.2978 2.45714 14.8507 2.90424 14.3011 2.90424Z" />
  </svg>
);

export const SVG_TREND_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8047 3.52827C16.0651 3.78862 16.0651 4.21073 15.8047 4.47108L9.47141 10.8044C9.21106 11.0648 8.78895 11.0648 8.5286 10.8044L5.66667 7.94248L1.13807 12.4711C0.877722 12.7314 0.455612 12.7314 0.195262 12.4711C-0.0650874 12.2107 -0.0650874 11.7886 0.195262 11.5283L5.19526 6.52827C5.45561 6.26792 5.87772 6.26792 6.13807 6.52827L9 9.3902L14.8619 3.52827C15.1223 3.26792 15.5444 3.26792 15.8047 3.52827Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.667 3.99967C10.667 3.63148 10.9655 3.33301 11.3337 3.33301H15.3337C15.7018 3.33301 16.0003 3.63148 16.0003 3.99967V7.99967C16.0003 8.36786 15.7018 8.66634 15.3337 8.66634C14.9655 8.66634 14.667 8.36786 14.667 7.99967V4.66634H11.3337C10.9655 4.66634 10.667 4.36786 10.667 3.99967Z"
      fill="#18A0FB"
    />
  </svg>
);

export const SVG_PAUSE_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2H3V14H7V2Z"
      stroke="#18A0FB"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="#FFFFFF"
    />
    <path
      d="M13 2H9V14H13V2Z"
      stroke="#18A0FB"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="#FFFFFF"
    />
  </svg>
);

export const SVG_EBOX_GALLERY_ICON = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.1282 7.42249C9.00153 7.42249 8.08811 8.33586 8.08811 9.4626C8.08811 10.5893 9.00148 11.5027 10.1282 11.5027C11.2549 11.5027 12.1684 10.5893 12.1684 9.4626C12.1684 8.33586 11.255 7.42249 10.1282 7.42249ZM10.1282 10.5312C9.53804 10.5312 9.05959 10.0528 9.05959 9.46256C9.05959 8.87236 9.53804 8.39392 10.1282 8.39392C10.7184 8.39392 11.1969 8.87236 11.1969 9.46256C11.1969 10.0528 10.7184 10.5312 10.1282 10.5312Z" />
    <path d="M18.2644 2.75931L5.00379 1.25356C4.48913 1.18038 3.96769 1.33063 3.57088 1.66645C3.17412 1.9741 2.91979 2.43013 2.86656 2.92936L2.62371 4.92089H1.87077C0.802133 4.92089 0.000656342 5.86806 0.000656342 6.9367V16.87C-0.0262595 17.8891 0.778007 18.737 1.79709 18.764C1.82163 18.7646 1.84622 18.7647 1.87077 18.7644H15.2043C16.2729 18.7644 17.2444 17.9387 17.2444 16.87V16.4815C17.5757 16.4174 17.89 16.2851 18.1673 16.0929C18.5608 15.7616 18.8127 15.2924 18.8716 14.7814L19.9888 4.92089C20.1027 3.84979 19.3341 2.88626 18.2644 2.75931ZM16.2729 16.87C16.2729 17.4044 15.7386 17.7929 15.2043 17.7929H1.87077C1.3881 17.8071 0.985337 17.4273 0.971159 16.9446C0.970415 16.9198 0.97074 16.8949 0.972135 16.87V15.0728L4.73663 12.3041C5.18885 11.9569 5.82581 11.9878 6.24242 12.377L8.8897 14.7085C9.29172 15.046 9.79777 15.2347 10.3227 15.2428C10.733 15.2478 11.1367 15.1385 11.4884 14.9271L16.2729 12.1584V16.87H16.2729ZM16.2729 11.0169L10.9783 14.1013C10.5237 14.3707 9.94825 14.3219 9.5454 13.9799L6.87385 11.6241C6.10817 10.9661 4.98905 10.9258 4.178 11.5269L0.972135 13.8584V6.9367C0.972135 6.40238 1.33645 5.89237 1.87077 5.89237H15.2043C15.7751 5.91604 16.2361 6.36659 16.2729 6.9367V11.0169ZM19.0183 4.78976C19.0179 4.79296 19.0177 4.79622 19.0173 4.79942L17.8758 14.6599C17.8778 14.9156 17.7612 15.1577 17.5601 15.3157C17.4629 15.4128 17.2443 15.4614 17.2443 15.51V6.9367C17.206 5.83027 16.311 4.94595 15.2042 4.92089H3.59515L3.81373 3.02651C3.86114 2.7812 3.9894 2.5589 4.17804 2.39504C4.39105 2.24777 4.64858 2.17911 4.90668 2.20072L18.1431 3.73079C18.6771 3.7815 19.069 4.25562 19.0183 4.78976Z" />
  </svg>
);

export const SVG_UP_ICON = (
  <svg
    className=""
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M5.57169 2.87196L0.177143 8.26831C-0.0590474 8.5051 -0.0590474 8.88873 0.177143 9.12612C0.413333 9.36291 0.796967 9.36291 1.03316 9.12612L5.99968 4.15781L10.9662 9.12552C11.2024 9.36231 11.586 9.36231 11.8228 9.12552C12.059 8.88874 12.059 8.5045 11.8228 8.26771L6.42826 2.87137C6.19451 2.63817 5.80484 2.63817 5.57169 2.87196Z"
        fill="#18A0FB"
      />
    </g>
  </svg>
);

export const SVG_DOUBLE_UP_ICON = (
  <svg
    className=""
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M6.50838 7.83711L1.1555 13.2748C0.921139 13.5134 0.92409 13.897 1.1621 14.1326C1.4001 14.3675 1.78373 14.3646 2.01809 14.126L6.94624 9.11962L11.9508 14.049C12.1888 14.2839 12.5725 14.281 12.8074 14.0424C13.0418 13.8038 13.0388 13.4196 12.8008 13.1846L7.36491 7.82992C7.12938 7.59852 6.73972 7.60152 6.50838 7.83711Z"
        fill="#18A0FB"
      />
    </g>
    <g clipPath="url(#clip1)">
      <path
        d="M6.58935 2.88323L1.19146 8.27623C0.955119 8.51288 0.954882 8.89651 1.19092 9.13404C1.42697 9.37098 1.8106 9.37121 2.04694 9.13457L7.01654 4.16934L11.98 9.14013C12.216 9.37707 12.5997 9.3773 12.8366 9.14066C13.0729 8.90402 13.0732 8.51979 12.8371 8.28285L7.44591 2.88316C7.21231 2.64982 6.82265 2.64958 6.58935 2.88323Z"
        fill="#18A0FB"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(1.00781 17.0078) rotate(-90.4408)"
        />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(1.01172 12.0078) rotate(-89.9645)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_QUESTION_ICON = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.5175 5.17673C10.741 4.91792 9.83522 5.17673 9.18813 5.69434C8.54104 6.21195 8.15283 6.98844 8.15283 7.89434C8.15283 8.28255 8.41164 8.54143 8.79992 8.54143C9.18813 8.54143 9.44701 8.28262 9.44701 7.89434C9.44701 7.50613 9.57641 6.98844 9.96462 6.72964C10.3528 6.47083 10.7411 6.34143 11.2587 6.47083C11.9058 6.60023 12.294 7.11792 12.4234 7.63553C12.5528 8.28262 12.4234 8.80023 11.9058 9.18852C10.8705 9.96501 10.3528 11.1297 10.3528 12.2944C10.3528 12.6826 10.6116 12.9415 10.9999 12.9415C11.3881 12.9415 11.647 12.6827 11.5175 12.2944C11.5175 11.5179 12.0351 10.7414 12.6822 10.2238C13.5881 9.44732 13.9763 8.41202 13.7175 7.37673C13.4587 6.21202 12.5528 5.43553 11.5175 5.17673Z" />
    <path d="M10.4824 15.659C10.353 15.7884 10.353 16.0472 10.353 16.1766C10.353 16.306 10.353 16.4354 10.4824 16.5648C10.6118 16.6942 10.8706 16.8236 11 16.8236C11.1294 16.8236 11.3882 16.6942 11.3882 16.5648C11.5177 16.5648 11.6471 16.306 11.6471 16.1766C11.6471 15.9178 11.5177 15.7884 11.3882 15.659C11.1294 15.4001 10.7412 15.4001 10.4824 15.659Z" />
    <path
      className="question-icon"
      d="M21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11Z"
    />
  </svg>
);

export const SVG_SEND_ICON = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path d="M5.10413 10.2737V12.9792C5.10413 13.1682 5.22546 13.3356 5.40513 13.3951C5.45004 13.4097 5.49613 13.4167 5.54163 13.4167C5.67813 13.4167 5.80996 13.3525 5.89396 13.2382L7.47654 11.0845L5.10413 10.2737Z" />
      <path d="M13.8158 0.08025C13.6816 -0.0148333 13.5055 -0.0276667 13.3596 0.04875L0.234621 6.90292C0.0794543 6.984 -0.012129 7.14967 0.000704331 7.32408C0.014121 7.49908 0.130204 7.64842 0.295288 7.705L3.94404 8.95217L11.7146 2.308L5.70162 9.55242L11.8167 11.6425C11.8622 11.6577 11.91 11.6658 11.9579 11.6658C12.0372 11.6658 12.116 11.6443 12.1854 11.6023C12.2962 11.5346 12.3715 11.4208 12.3907 11.2931L13.9949 0.501417C14.0188 0.338083 13.95 0.175917 13.8158 0.08025Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_RESEND_ICON = (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.499333 13.6527C0.46 13.6527 0.420667 13.648 0.381333 13.638C0.160667 13.5813 0 13.3947 0 13.1667C0 7.98399 4.17133 3.75732 9.33333 3.66799V0.833325C9.33333 0.632658 9.454 0.451325 9.63866 0.372658C9.82266 0.294658 10.038 0.333991 10.1813 0.474658L15.848 5.97466C15.9453 6.06866 16 6.19799 16 6.33333C16 6.46866 15.9453 6.59799 15.848 6.69199L10.1813 12.192C10.0367 12.332 9.822 12.3707 9.63866 12.294C9.454 12.2153 9.33333 12.034 9.33333 11.8333V8.99999H8.388C5.29733 8.99999 2.448 10.68 0.951333 13.384C0.86 13.548 0.682 13.6527 0.499333 13.6527ZM9.5 4.66666C5.46267 4.66666 2.074 7.49533 1.212 11.2747C2.996 9.21933 5.60467 7.99999 8.388 7.99999H9.83333C10.1093 7.99999 10.3333 8.22399 10.3333 8.49999V10.6513L14.782 6.33333L10.3333 2.01532V4.16666C10.3333 4.44266 10.1093 4.66666 9.83333 4.66666H9.5Z" />
  </svg>
);

export const SVG_SETTINGS_ICON = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24.6692 15.7284L22.8442 16.0379C22.6541 16.6517 22.4097 17.2437 22.111 17.8086L23.1864 19.313C23.6426 19.9539 23.572 20.8284 23.0126 21.3824L21.3941 23.0009C21.0899 23.3051 20.688 23.4734 20.2589 23.4734C19.9222 23.4734 19.6017 23.3703 19.3302 23.1747L17.8202 22.0993C17.2337 22.4089 16.6199 22.6642 15.9844 22.8543L15.6803 24.6575C15.5499 25.4342 14.8819 25.999 14.0943 25.999H11.8077C11.0202 25.999 10.3521 25.4342 10.2218 24.6575L9.90677 22.8108C9.29846 22.6207 8.70644 22.3709 8.14158 22.0667L6.64796 23.1421C6.3764 23.3377 6.05052 23.4409 5.71377 23.4409C5.2847 23.4409 4.87735 23.2725 4.57862 22.9683L2.95465 21.3498C2.40065 20.7958 2.32462 19.9214 2.78085 19.2805L3.86712 17.7542C3.56839 17.184 3.32941 16.5919 3.14475 15.9782L1.34154 15.674C0.56486 15.5437 0 14.8756 0 14.0881V11.8015C0 11.0139 0.56486 10.3459 1.34154 10.2155L3.1882 9.90052C3.3783 9.29221 3.62814 8.7002 3.93229 8.13534L2.86232 6.64715C2.40609 6.00625 2.47669 5.13181 3.03612 4.57781L4.65466 2.95927C4.95882 2.65512 5.36074 2.48674 5.78981 2.48674C6.12655 2.48674 6.447 2.58994 6.71857 2.78547L8.24478 3.87173C8.79334 3.58387 9.36907 3.35032 9.96108 3.16566L10.2652 1.34073C10.3956 0.564047 11.0636 -0.000812531 11.8512 -0.000812531H14.1432C14.9308 -0.000812531 15.5988 0.564047 15.7292 1.34073L16.0388 3.16566C16.6525 3.35576 17.2445 3.60017 17.8094 3.89889L19.3139 2.82349C19.5854 2.62796 19.9113 2.52476 20.248 2.52476C20.6771 2.52476 21.079 2.69313 21.3832 2.99729L23.0017 4.61583C23.5557 5.16983 23.6318 6.04427 23.1755 6.68517L22.1001 8.19508C22.3989 8.76538 22.6487 9.35739 22.8334 9.9657L24.6583 10.2699C25.435 10.4002 25.9998 11.0683 25.9998 11.8558V14.1424C26.0107 14.9299 25.4458 15.598 24.6692 15.7284ZM24.5442 11.8558C24.5442 11.7852 24.4954 11.7255 24.4248 11.7146L22.1436 11.3344C21.8557 11.2855 21.6276 11.0737 21.557 10.7967C21.3506 9.99829 21.0356 9.23247 20.6119 8.52096C20.4653 8.27112 20.4762 7.96153 20.6445 7.72256L21.9861 5.83245C22.0241 5.77814 22.0187 5.69667 21.9698 5.64778L20.3512 4.02924C20.3132 3.99122 20.2752 3.98579 20.248 3.98579C20.2155 3.98579 20.1883 3.99666 20.1666 4.01295L18.2819 5.35449C18.0484 5.52286 17.7333 5.53373 17.4835 5.38708C16.772 4.96343 16.0062 4.64842 15.2078 4.44203C14.9253 4.37142 14.7135 4.13787 14.6701 3.85544L14.2844 1.57428C14.2736 1.50367 14.2138 1.45479 14.1432 1.45479H11.8566C11.786 1.45479 11.7263 1.50367 11.7154 1.57428L11.3352 3.85544C11.2863 4.1433 11.0745 4.37142 10.7975 4.44203C10.0208 4.64298 9.2713 4.95257 8.57066 5.35449C8.4566 5.41967 8.32625 5.45226 8.20133 5.45226C8.05468 5.45226 7.9026 5.4088 7.77768 5.31647L5.87671 3.96407C5.84956 3.94777 5.8224 3.93691 5.79524 3.93691C5.77352 3.93691 5.73007 3.94234 5.69205 3.98036L4.07351 5.5989C4.02463 5.64778 4.01919 5.72382 4.05721 5.78357L5.39332 7.65738C5.5617 7.89636 5.57256 8.21138 5.42591 8.46122C5.00227 9.16729 4.67639 9.93311 4.47 10.7315C4.39396 11.0085 4.16584 11.2203 3.88341 11.2692L1.58595 11.6603C1.51534 11.6711 1.46646 11.7309 1.46646 11.8015V14.0881C1.46646 14.1587 1.51534 14.2184 1.58595 14.2293L3.85082 14.6095C4.13868 14.6584 4.37223 14.8702 4.44284 15.1526C4.6438 15.951 4.95339 16.7223 5.3716 17.4338C5.51824 17.6836 5.50195 17.9932 5.33358 18.2268L3.98117 20.1277C3.94316 20.1821 3.94859 20.2635 3.99747 20.3124L5.61601 21.9309C5.65403 21.969 5.69205 21.9744 5.7192 21.9744C5.75179 21.9744 5.77895 21.9635 5.80067 21.9472L7.67449 20.6111C7.91347 20.4428 8.22849 20.4319 8.47833 20.5785C9.1844 21.0022 9.95022 21.3281 10.7486 21.5345C11.0256 21.6105 11.2374 21.8386 11.2863 22.121L11.6774 24.4185C11.6883 24.4891 11.748 24.538 11.8186 24.538H14.1052C14.1758 24.538 14.2355 24.4891 14.2464 24.4185L14.6266 22.1536C14.6755 21.8658 14.8873 21.6322 15.1697 21.5616C15.9899 21.3552 16.772 21.0348 17.4998 20.6057C17.7496 20.4591 18.0592 20.4699 18.2982 20.6383L20.172 21.9853C20.1992 22.0016 20.2263 22.0124 20.2535 22.0124C20.2752 22.0124 20.3187 22.007 20.3567 21.969L21.9752 20.3504C22.0241 20.3015 22.0295 20.2255 21.9915 20.1658L20.65 18.2811C20.4816 18.0475 20.4707 17.7325 20.6174 17.4827C21.041 16.7712 21.356 16.0054 21.5624 15.2069C21.633 14.9245 21.8666 14.7127 22.149 14.6692L24.4302 14.2836C24.5008 14.2728 24.5497 14.213 24.5497 14.1424V11.8558H24.5442Z" />
    <path d="M13.0032 18.6133C9.90729 18.6133 7.39258 16.0986 7.39258 13.0027C7.39258 9.90684 9.90729 7.39213 13.0032 7.39213C16.099 7.39213 18.6137 9.90684 18.6137 13.0027C18.6137 16.0986 16.099 18.6133 13.0032 18.6133ZM13.0032 8.85859C10.7166 8.85859 8.85904 10.7161 8.85904 13.0027C8.85904 15.2893 10.7166 17.1468 13.0032 17.1468C15.2897 17.1468 17.1473 15.2893 17.1473 13.0027C17.1473 10.7161 15.2897 8.85859 13.0032 8.85859Z" />
  </svg>
);

export const SVG_USER_ICON = (
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.9055 14.0095C11.9324 14.0095 11.9593 14.0095 11.9916 14.0095C12.0024 14.0095 12.0132 14.0095 12.0239 14.0095C12.0401 14.0095 12.0616 14.0095 12.0778 14.0095C13.6553 13.9826 14.9314 13.428 15.8736 12.3674C17.9465 10.0306 17.6019 6.02485 17.5642 5.64258C17.4296 2.77283 16.0728 1.39988 14.9529 0.759163C14.1184 0.279975 13.1438 0.0215366 12.0562 0H12.0186C12.0132 0 12.0024 0 11.997 0H11.9647C11.3671 0 10.1933 0.0969145 9.06804 0.737627C7.93738 1.37834 6.55904 2.75129 6.42443 5.64258C6.38674 6.02485 6.04216 10.0306 8.11505 12.3674C9.05189 13.428 10.3279 13.9826 11.9055 14.0095ZM7.862 5.77718C7.862 5.76103 7.86738 5.74487 7.86738 5.73411C8.04506 1.87368 10.7856 1.4591 11.9593 1.4591H11.9809C11.9916 1.4591 12.0078 1.4591 12.0239 1.4591C13.4777 1.49141 15.949 2.08366 16.1159 5.73411C16.1159 5.75026 16.1159 5.76641 16.1213 5.77718C16.1266 5.81487 16.5035 9.47608 14.7914 11.4036C14.113 12.1682 13.2084 12.545 12.0186 12.5558C12.0078 12.5558 12.0024 12.5558 11.9916 12.5558C11.9809 12.5558 11.9755 12.5558 11.9647 12.5558C10.7802 12.545 9.87028 12.1682 9.19726 11.4036C7.49049 9.48685 7.85661 5.80948 7.862 5.77718Z" />
    <path d="M23.0565 20.6535C23.0565 20.6481 23.0565 20.6427 23.0565 20.6374C23.0565 20.5943 23.0511 20.5512 23.0511 20.5027C23.0188 19.4367 22.9488 16.9438 20.6121 16.147C20.5959 16.1416 20.5744 16.1362 20.5583 16.1308C18.13 15.5116 16.111 14.1118 16.0894 14.0956C15.761 13.8641 15.3087 13.9449 15.0772 14.2733C14.8457 14.6017 14.9265 15.054 15.2549 15.2855C15.3464 15.3501 17.4893 16.8415 20.1706 17.5307C21.4251 17.9776 21.5651 19.3182 21.6028 20.5458C21.6028 20.5943 21.6028 20.6374 21.6082 20.6804C21.6136 21.165 21.5812 21.9134 21.4951 22.3441C20.6229 22.8395 17.2039 24.5516 12.0029 24.5516C6.82333 24.5516 3.38286 22.8341 2.50525 22.3387C2.4191 21.908 2.38141 21.1596 2.39218 20.675C2.39218 20.632 2.39757 20.5889 2.39757 20.5404C2.43525 19.3129 2.57524 17.9722 3.82975 17.5253C6.51105 16.8361 8.65393 15.3394 8.74546 15.2801C9.0739 15.0486 9.15466 14.5963 8.92314 14.2679C8.69162 13.9395 8.23935 13.8587 7.91092 14.0902C7.88939 14.1064 5.8811 15.5063 3.44209 16.1254C3.42055 16.1308 3.4044 16.1362 3.38825 16.1416C1.05153 16.9438 0.981537 19.4367 0.949232 20.4974C0.949232 20.5458 0.949232 20.5889 0.943848 20.632C0.943848 20.6374 0.943848 20.6427 0.943848 20.6481C0.938464 20.9281 0.93308 22.3657 1.21844 23.0871C1.27228 23.2271 1.3692 23.3456 1.49841 23.4263C1.65994 23.534 5.53113 26 12.0083 26C18.4854 26 22.3566 23.5286 22.5181 23.4263C22.6419 23.3456 22.7442 23.2271 22.7981 23.0871C23.0673 22.371 23.0619 20.9335 23.0565 20.6535Z" />
  </svg>
);

export const SVG_CONTACTS_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <g clip-path="url(#clip0_1_16177)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.851342 9.52126C1.39832 8.97428 2.14019 8.66699 2.91374 8.66699H7.5804C8.35395 8.66699 9.09582 8.97428 9.6428 9.52126C10.1898 10.0682 10.4971 10.8101 10.4971 11.5837V12.7503C10.4971 13.0725 10.2359 13.3337 9.91374 13.3337C9.59157 13.3337 9.3304 13.0725 9.3304 12.7503V11.5837C9.3304 11.1195 9.14603 10.6744 8.81784 10.3462C8.48965 10.018 8.04453 9.83366 7.5804 9.83366H2.91374C2.44961 9.83366 2.00449 10.018 1.6763 10.3462C1.34811 10.6744 1.16374 11.1195 1.16374 11.5837V12.7503C1.16374 13.0725 0.90257 13.3337 0.580404 13.3337C0.258238 13.3337 -0.00292969 13.0725 -0.00292969 12.7503V11.5837C-0.00292969 10.8101 0.304361 10.0682 0.851342 9.52126Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.24675 2.83366C4.28025 2.83366 3.49674 3.61716 3.49674 4.58366C3.49674 5.55016 4.28025 6.33366 5.24675 6.33366C6.21324 6.33366 6.99675 5.55016 6.99675 4.58366C6.99675 3.61716 6.21324 2.83366 5.24675 2.83366ZM2.33008 4.58366C2.33008 2.97283 3.63591 1.66699 5.24675 1.66699C6.85758 1.66699 8.16341 2.97283 8.16341 4.58366C8.16341 6.19449 6.85758 7.50033 5.24675 7.50033C3.63591 7.50033 2.33008 6.19449 2.33008 4.58366Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0987 9.18C11.1793 8.86806 11.4974 8.68048 11.8094 8.76102C12.4351 8.92258 12.9895 9.28737 13.3854 9.79812C13.7813 10.3089 13.9964 10.9367 13.9969 11.5829L13.9969 12.75C13.9969 13.0722 13.7357 13.3333 13.4136 13.3333C13.0914 13.3333 12.8302 13.0722 12.8302 12.75L12.8302 11.5838C12.8302 11.5837 12.8302 11.5838 12.8302 11.5838C12.8299 11.1961 12.7008 10.8193 12.4633 10.5129C12.2258 10.2065 11.8932 9.98758 11.5177 9.89064C11.2058 9.8101 11.0182 9.49193 11.0987 9.18Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.76544 2.18115C8.84535 1.86905 9.16314 1.68082 9.47523 1.76073C10.1026 1.92137 10.6587 2.28624 11.0558 2.79783C11.4529 3.30942 11.6685 3.93863 11.6685 4.58625C11.6685 5.23388 11.4529 5.86308 11.0558 6.37467C10.6587 6.88626 10.1026 7.25114 9.47523 7.41177C9.16314 7.49168 8.84535 7.30346 8.76544 6.99136C8.68553 6.67926 8.87376 6.36148 9.18585 6.28157C9.56229 6.18518 9.89593 5.96626 10.1342 5.6593C10.3725 5.35235 10.5018 4.97483 10.5018 4.58625C10.5018 4.19768 10.3725 3.82016 10.1342 3.5132C9.89593 3.20625 9.56229 2.98732 9.18585 2.89094C8.87376 2.81103 8.68553 2.49325 8.76544 2.18115Z"
        fill="#29394D"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_16177">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(-0.00292969 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_ENVELOPE_ICON = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M25.9801 10.0343C25.9801 9.99524 25.9714 9.93618 25.9562 9.90216C25.9162 9.75723 25.8274 9.62484 25.6944 9.53242L21.9726 6.94522V4.17175C21.9726 3.80409 21.6744 3.50591 21.3067 3.50591H17.0249L13.3817 0.97304C13.154 0.814551 12.8517 0.813891 12.6233 0.971719L8.95659 3.50591H4.69351C4.32575 3.50591 4.02766 3.80409 4.02766 4.17175V6.91257L0.287727 9.49738C0.103746 9.62454 0.00421484 9.82782 0.00106641 10.0357C0.000863281 10.0396 0 10.0433 0 10.0473L0.0198555 24.4812C0.0201094 24.6577 0.0904922 24.827 0.215465 24.9517C0.340285 25.0762 0.509387 25.146 0.685699 25.146C0.686055 25.146 0.686309 25.146 0.686613 25.146L25.3351 25.1122C25.7027 25.1117 26.0005 24.8131 26 24.4454L25.9801 10.0343ZM21.9725 8.56712L24.1002 10.0458L21.9725 11.5249V8.56712ZM13.0008 2.32997L14.6923 3.50586H11.2995L13.0008 2.32997ZM5.35935 4.83759H20.6409V12.4508L15.5101 16.0177L13.4182 14.3951C13.415 14.3925 13.4122 14.391 13.409 14.3887C13.1752 14.2133 12.8446 14.2068 12.6019 14.3951L10.4949 16.0295L5.35935 12.4802V4.83759ZM4.02766 8.53132V11.5599L1.83666 10.0457L4.02766 8.53132ZM1.33341 11.3174L9.39082 16.8858L1.34966 23.123L1.33341 11.3174ZM2.63428 23.8117L13.0101 15.7637L23.3487 23.7832L2.63428 23.8117ZM16.6128 16.8731L24.6502 11.2853L24.6665 23.1203L16.6128 16.8731Z" />
    <path d="M17.5086 7.5011H8.49311C8.12546 7.5011 7.82727 7.79929 7.82727 8.16694C7.82727 8.5346 8.12546 8.83279 8.49311 8.83279H17.5086C17.8764 8.83279 18.1744 8.5346 18.1744 8.16694C18.1744 7.79929 17.8764 7.5011 17.5086 7.5011Z" />
    <path d="M17.5086 10.9634H8.49311C8.12546 10.9634 7.82727 11.2616 7.82727 11.6292C7.82727 11.9969 8.12546 12.2951 8.49311 12.2951H17.5086C17.8764 12.2951 18.1744 11.9969 18.1744 11.6292C18.1744 11.2616 17.8764 10.9634 17.5086 10.9634Z" />
  </svg>
);

export const SVG_ADD_ICON = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1592 12.1597L12.1592 7.11772C12.1592 6.6536 12.5355 6.27736 12.9995 6.27739C13.4637 6.27739 13.8399 6.6536 13.8399 7.11771L13.8399 12.1597L18.8819 12.1597C19.346 12.1597 19.7222 12.5359 19.7222 13C19.7222 13.4641 19.346 13.8404 18.8819 13.8404L13.8399 13.8403L13.8399 18.8823C13.8399 19.3464 13.4637 19.7227 12.9996 19.7227C12.5355 19.7227 12.1593 19.3465 12.1593 18.8823L12.1593 13.8403L7.11727 13.8403C6.65318 13.8404 6.27694 13.4641 6.27694 13C6.27694 12.5359 6.65315 12.1597 7.11727 12.1597L12.1592 12.1597Z"
    />
    <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
  </svg>
);

export const SVG_CLOSE_ICON = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8118 13.0706L8.24661 9.50538C7.91843 9.1772 7.91843 8.64512 8.24661 8.31698C8.57479 7.9888 9.10683 7.9888 9.43501 8.31698L13.0003 11.8822L16.5655 8.31694C16.8937 7.98876 17.4257 7.98876 17.7539 8.31694C18.082 8.64512 18.082 9.1772 17.7539 9.50534L14.1887 13.0705L17.7539 16.6358C18.082 16.964 18.082 17.496 17.7539 17.8242C17.4257 18.1524 16.8937 18.1524 16.5655 17.8242L13.0003 14.2589L9.43501 17.8242C9.10688 18.1524 8.57479 18.1524 8.24661 17.8242C7.91843 17.496 7.91843 16.964 8.24661 16.6358L11.8118 13.0706Z"
    />
    <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
  </svg>
);

export const SVG_CHECK_ICON = (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.258 18.9999C10.885 18.9999 10.5322 18.8254 10.3054 18.5261L7.24231 14.4809C6.84391 13.9548 6.94762 13.2056 7.47374 12.8071C8.00071 12.4083 8.74934 12.5127 9.14791 13.0385L11.1625 15.6987L16.2295 7.56306C16.5783 7.00334 17.3149 6.83209 17.8759 7.18043C18.4361 7.52912 18.6072 8.26626 18.2581 8.82649L12.2725 18.4368C12.0646 18.7709 11.7056 18.9811 11.3125 18.9989C11.2942 18.9996 11.2762 18.9999 11.258 18.9999Z" />
    <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
  </svg>
);

export const IS_EMAIL_VALID = (isValid) =>
  isValid ? (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        height: 14,
        width: 14,
        margin: "auto",
        marginRight: 15,
        marginLeft: 5,
      }}
    >
      <path
        fill="#06D9B1"
        d="M5.29582 13.9999C4.86062 13.9999 4.44902 13.7963 4.18442 13.4471L0.61082 8.7277C0.14602 8.1139 0.26702 7.2399 0.88082 6.7749C1.49562 6.3097 2.36902 6.4315 2.83402 7.0449L5.18442 10.1485L11.0958 0.656902C11.5028 0.00390224 12.3622 -0.195898 13.0166 0.210502C13.6702 0.617302 13.8698 1.4773 13.4626 2.1309L6.47942 13.3429C6.23682 13.7327 5.81802 13.9779 5.35942 13.9987C5.33802 13.9995 5.31702 13.9999 5.29582 13.9999Z"
      />
    </svg>
  ) : (
    SVG_INVALID
  );

export const IS_EMAIL_GENERIC_VALID = (isValid) =>
  isValid ? (
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        height: 14,
        width: 14,
        margin: "auto",
        marginRight: 15,
        marginLeft: 5,
        position: "relative",
      }}
    >
      <path
        fill="#06D9B1"
        d="M5.29582 13.9999C4.86062 13.9999 4.44902 13.7963 4.18442 13.4471L0.61082 8.7277C0.14602 8.1139 0.26702 7.2399 0.88082 6.7749C1.49562 6.3097 2.36902 6.4315 2.83402 7.0449L5.18442 10.1485L11.0958 0.656902C11.5028 0.00390224 12.3622 -0.195898 13.0166 0.210502C13.6702 0.617302 13.8698 1.4773 13.4626 2.1309L6.47942 13.3429C6.23682 13.7327 5.81802 13.9779 5.35942 13.9987C5.33802 13.9995 5.31702 13.9999 5.29582 13.9999Z"
      />
    </svg>
  ) : (
    SVG_INVALID
  );

export const IS_EMAIL_VALID_UA = (isValid) =>
  isValid ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_49063_25740)">
        <path
          d="M16.5 8.31039V9.00039C16.4991 10.6177 15.9754 12.1914 15.007 13.4868C14.0386 14.7821 12.6775 15.7297 11.1265 16.1883C9.57557 16.6469 7.91794 16.5918 6.40085 16.0313C4.88376 15.4708 3.58849 14.435 2.70822 13.0782C1.82795 11.7214 1.40984 10.1164 1.51626 8.50262C1.62267 6.88881 2.24791 5.35263 3.29871 4.12319C4.34951 2.89375 5.76959 2.03692 7.34714 1.6805C8.92469 1.32407 10.5752 1.48714 12.0525 2.14539"
          stroke="#06D9B1"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 3L9 10.5075L6.75 8.2575"
          stroke="#06D9B1"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_49063_25740">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FE3745"
        d="M11.8118 13.0706L8.24661 9.50538C7.91843 9.1772 7.91843 8.64512 8.24661 8.31698C8.57479 7.9888 9.10683 7.9888 9.43501 8.31698L13.0003 11.8822L16.5655 8.31694C16.8937 7.98876 17.4257 7.98876 17.7539 8.31694C18.082 8.64512 18.082 9.1772 17.7539 9.50534L14.1887 13.0705L17.7539 16.6358C18.082 16.964 18.082 17.496 17.7539 17.8242C17.4257 18.1524 16.8937 18.1524 16.5655 17.8242L13.0003 14.2589L9.43501 17.8242C9.10688 18.1524 8.57479 18.1524 8.24661 17.8242C7.91843 17.496 7.91843 16.964 8.24661 16.6358L11.8118 13.0706Z"
      />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" stroke="#FE3745" />
    </svg>
  );
export const SVG_VALID_ICON = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.29503 14C4.85983 14 4.44823 13.7964 4.18363 13.4472L0.610026 8.72782C0.145226 8.11402 0.266226 7.24002 0.880026 6.77502C1.49483 6.30982 2.36823 6.43162 2.83323 7.04502L5.18363 10.1486L11.095 0.657024C11.502 0.00402431 12.3614 -0.195776 13.0158 0.210624C13.6694 0.617424 13.869 1.47742 13.4618 2.13102L6.47863 13.343C6.23603 13.7328 5.81723 13.978 5.35863 13.9988C5.33723 13.9996 5.31623 14 5.29503 14Z"
      fill="#06D9B1"
    />
  </svg>
);

export const SVG_WARNING_ICON = (
  <svg
    width="3"
    height="14"
    viewBox="0 0 3 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.115347 1.29323C0.115347 0.494452 0.711379 2.38419e-07 1.49967 2.38419e-07C2.26938 2.38419e-07 2.88465 0.512893 2.88465 1.29323V8.61716C2.88465 9.39691 2.26938 9.91039 1.49967 9.91039C0.711379 9.91039 0.115347 9.41529 0.115347 8.61716V1.29323ZM0 12.5159C0 11.6981 0.672948 11.0325 1.49967 11.0325C2.32645 11.0325 3 11.6982 3 12.5159C3 13.3343 2.32645 14 1.49967 14C0.672948 14 0 13.3343 0 12.5159Z" />
  </svg>
);
export const SVG_MINUS = (
  <svg
    width="16"
    height="3"
    viewBox="0 0 16 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="2.66667" rx="1" fill="#FE3745" />
  </svg>
);

export const SVG_PLUS = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.11534 15.1317L9.11534 9.11625L15.1308 9.11625C15.4048 9.11625 15.999 8.74415 15.999 7.99997C15.999 7.25579 15.4048 6.88368 15.1308 6.88368L9.11531 6.88368L9.11531 0.868214C9.11534 0.594218 8.74323 -3.17161e-07 7.99909 -3.49688e-07C7.25494 -3.82216e-07 6.8828 0.594217 6.8828 0.868214L6.8828 6.88371L0.8673 6.88371C0.593335 6.88371 -0.000915845 7.25579 -0.000915877 8C-0.00091591 8.74421 0.593335 9.11628 0.8673 9.11628L6.8828 9.11628L6.8828 15.1318C6.8828 15.4057 7.25487 16 7.99909 16C8.7433 16 9.11534 15.4057 9.11534 15.1317Z"
      fill="#18A0FB"
    />
  </svg>
);

export const SVG_INVALID = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.29456 12.8588L8.48472 9.66862L11.6749 12.8588C11.8202 13.0041 12.3327 13.1219 12.7273 12.7272C13.122 12.3326 13.0042 11.8201 12.8589 11.6748L9.6687 8.4846L12.8589 5.29442C13.0042 5.14913 13.122 4.63666 12.7274 4.24201C12.3327 3.84737 11.8202 3.96514 11.6749 4.11045L8.48472 7.30065L5.29452 4.11045C5.14923 3.96516 4.63676 3.84733 4.24208 4.24201C3.8474 4.63669 3.96523 5.14916 4.11052 5.29445L7.30072 8.48465L4.11052 11.6749C3.96523 11.8201 3.8474 12.3326 4.24208 12.7273C4.63676 13.122 5.14925 13.0041 5.29456 12.8588Z"
      fill="#FE3745"
    />
  </svg>
);

export const SVG_COMPLETE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M4.78292 6.72192H3.27906V5.21805C3.27906 5.14955 3.18604 5.001 2.99999 5.001C2.81395 5.001 2.72092 5.14955 2.72092 5.21805V6.72193H1.21705C1.14855 6.72192 1 6.81495 1 7.00098C1 7.18702 1.14855 7.28006 1.21705 7.28006H2.72093V8.78393C2.72093 8.85242 2.81395 9.00098 3 9.00098C3.18605 9.00098 3.27907 8.85242 3.27907 8.78393V7.28006H4.78295C4.85144 7.28006 5 7.18704 5 7.00098C5 6.81493 4.85142 6.72192 4.78292 6.72192Z"
      fill="#18A0FB"
    />
    <path
      d="M9.94112 9.62125C9.95816 9.62125 9.9752 9.62125 9.99565 9.62125C10.0025 9.62125 10.0093 9.62125 10.0161 9.62125C10.0263 9.62125 10.04 9.62125 10.0502 9.62125C11.0488 9.60469 11.8566 9.26341 12.4531 8.61069C13.7653 7.17271 13.5472 4.7076 13.5233 4.47236C13.4381 2.70636 12.5792 1.86146 11.8702 1.46718C11.342 1.17229 10.725 1.01325 10.0366 1H10.0127C10.0093 1 10.0025 1 9.99906 1H9.97861C9.60028 1 8.85726 1.05964 8.14491 1.45392C7.42916 1.84821 6.55662 2.69311 6.47141 4.47236C6.44755 4.7076 6.22942 7.17271 7.54164 8.61069C8.13469 9.26341 8.94247 9.60469 9.94112 9.62125ZM7.38144 4.55519C7.38144 4.54525 7.38485 4.53531 7.38485 4.52868C7.49733 2.15303 9.23218 1.89791 9.9752 1.89791H9.98884C9.99565 1.89791 10.0059 1.89791 10.0161 1.89791C10.9364 1.91779 12.5008 2.28225 12.6065 4.52868C12.6065 4.53862 12.6065 4.54856 12.6099 4.55519C12.6133 4.57838 12.8519 6.83144 11.768 8.01761C11.3385 8.4881 10.7659 8.72003 10.0127 8.72666C10.0059 8.72666 10.0025 8.72666 9.99565 8.72666C9.98883 8.72666 9.98543 8.72666 9.97861 8.72666C9.22877 8.72003 8.65276 8.4881 8.22671 8.01761C7.14627 6.83807 7.37803 4.57507 7.38144 4.55519Z"
      fill="#18A0FB"
    />
    <path
      d="M16.999 13.7099C16.999 13.7066 16.999 13.7032 16.999 13.6999C16.999 13.6734 16.9956 13.6469 16.9956 13.6171C16.9752 12.9611 16.9309 11.427 15.4517 10.9366C15.4414 10.9333 15.4278 10.93 15.4176 10.9267C13.8804 10.5456 12.6023 9.68418 12.5886 9.67424C12.3807 9.53177 12.0944 9.58147 11.9479 9.78358C11.8013 9.9857 11.8524 10.264 12.0603 10.4065C12.1183 10.4462 13.4748 11.364 15.1722 11.7881C15.9663 12.0631 16.0549 12.8882 16.0788 13.6436C16.0788 13.6734 16.0788 13.6999 16.0822 13.7264C16.0856 14.0246 16.0652 14.4852 16.0106 14.7503C15.4585 15.0551 13.2942 16.1087 10.0017 16.1087C6.72285 16.1087 4.54491 15.0518 3.98935 14.7469C3.93482 14.4819 3.91096 14.0213 3.91778 13.7231C3.91778 13.6966 3.92118 13.6701 3.92118 13.6403C3.94504 12.8849 4.03366 12.0598 4.82781 11.7848C6.52517 11.3607 7.88169 10.4396 7.93964 10.4032C8.14754 10.2607 8.19867 9.98238 8.05211 9.78027C7.90555 9.57816 7.61925 9.52846 7.41134 9.67093C7.39771 9.68087 6.12639 10.5423 4.5824 10.9234C4.56877 10.9267 4.55855 10.93 4.54832 10.9333C3.06909 11.427 3.02479 12.9611 3.00434 13.6138C3.00434 13.6436 3.00434 13.6701 3.00093 13.6966C3.00093 13.6999 3.00093 13.7032 3.00093 13.7066C2.99752 13.8788 2.99411 14.7635 3.17475 15.2075C3.20884 15.2936 3.27019 15.3665 3.35199 15.4162C3.45424 15.4825 5.90485 17 10.0051 17C14.1054 17 16.556 15.4792 16.6582 15.4162C16.7366 15.3665 16.8014 15.2936 16.8354 15.2075C17.0059 14.7668 17.0025 13.8822 16.999 13.7099Z"
      fill="#18A0FB"
    />
  </svg>
);

export const SVG_USER_PLUS_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.976311 10.3093C1.60143 9.6842 2.44928 9.33301 3.33333 9.33301H8C8.88406 9.33301 9.7319 9.6842 10.357 10.3093C10.9821 10.9344 11.3333 11.7823 11.3333 12.6663V13.9997C11.3333 14.3679 11.0349 14.6663 10.6667 14.6663C10.2985 14.6663 10 14.3679 10 13.9997V12.6663C10 12.1359 9.78929 11.6272 9.41421 11.2521C9.03914 10.8771 8.53043 10.6663 8 10.6663H3.33333C2.8029 10.6663 2.29419 10.8771 1.91912 11.2521C1.54405 11.6272 1.33333 12.1359 1.33333 12.6663V13.9997C1.33333 14.3679 1.03486 14.6663 0.666667 14.6663C0.298477 14.6663 0 14.3679 0 13.9997V12.6663C0 11.7823 0.35119 10.9344 0.976311 10.3093Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.66634 2.66634C4.56177 2.66634 3.66634 3.56177 3.66634 4.66634C3.66634 5.77091 4.56177 6.66634 5.66634 6.66634C6.77091 6.66634 7.66634 5.77091 7.66634 4.66634C7.66634 3.56177 6.77091 2.66634 5.66634 2.66634ZM2.33301 4.66634C2.33301 2.82539 3.82539 1.33301 5.66634 1.33301C7.50729 1.33301 8.99967 2.82539 8.99967 4.66634C8.99967 6.50729 7.50729 7.99967 5.66634 7.99967C3.82539 7.99967 2.33301 6.50729 2.33301 4.66634Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3337 4.66699C13.7018 4.66699 14.0003 4.96547 14.0003 5.33366V9.33366C14.0003 9.70185 13.7018 10.0003 13.3337 10.0003C12.9655 10.0003 12.667 9.70185 12.667 9.33366V5.33366C12.667 4.96547 12.9655 4.66699 13.3337 4.66699Z"
      fill="#18A0FB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.667 7.33366C10.667 6.96547 10.9655 6.66699 11.3337 6.66699H15.3337C15.7018 6.66699 16.0003 6.96547 16.0003 7.33366C16.0003 7.70185 15.7018 8.00033 15.3337 8.00033H11.3337C10.9655 8.00033 10.667 7.70185 10.667 7.33366Z"
      fill="#18A0FB"
    />
  </svg>
);

export const SVG_GRID = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 19 14"
    fill="#FE3745"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect y="4" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect y="8" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect y="12" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect x="10" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect x="10" y="4" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect x="10" y="8" width="9" height="2" rx="1" fill="#B5BEC8" />
    <rect x="10" y="12" width="9" height="2" rx="1" fill="#B5BEC8" />
  </svg>
);

export const SVG_LIST = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 19 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="19" height="2" rx="1" fill="#B5BEC8" />
    <rect y="4" width="19" height="2" rx="1" fill="#B5BEC8" />
    <rect y="8" width="19" height="2" rx="1" fill="#B5BEC8" />
    <rect y="12" width="19" height="2" rx="1" fill="#B5BEC8" />
  </svg>
);
<svg
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  width="28"
  viewBox="0 0 19 14"
  height="28"
>
  <rect rx="1" fill="#B5BEC8" width="22" height="2" />
  <rect y="4" height="2" rx="1" fill="#B5BEC8" width="19" />
  <rect y="8" height="2" rx="1" fill="#B5BEC8" width="19" />
  <rect y="12" height="2" rx="1" fill="#B5BEC8" width="19" />
</svg>;

export const SVG_MAXIMIZE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <rect
      x="1"
      y="1"
      width="12"
      height="12"
      rx="1"
      stroke="#C7E8FE"
      strokeWidth="1"
      fillOpacity="0"
    />
  </svg>
);
export const SVG_INFO_ICON = (
  <svg
    width="18"
    height="18"
    viewBox="0 -1 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99962 0C4.02971 0 0 4.02971 0 8.99962C0 13.9695 4.02971 18 8.99962 18C13.9695 18 18 13.9695 18 8.99962C18 4.02971 13.9695 0 8.99962 0ZM10.8731 13.9482C10.4099 14.131 10.0411 14.2697 9.76457 14.3657C9.48876 14.4617 9.168 14.5097 8.80305 14.5097C8.24229 14.5097 7.80571 14.3726 7.49486 14.099C7.184 13.8255 7.02933 13.4789 7.02933 13.0575C7.02933 12.8937 7.04076 12.7261 7.06362 12.5554C7.08724 12.3848 7.12457 12.1928 7.17562 11.9771L7.75543 9.92914C7.80648 9.73257 7.85067 9.54591 7.88571 9.37219C7.92076 9.19695 7.93752 9.03619 7.93752 8.8899C7.93752 8.62933 7.88343 8.44648 7.776 8.34362C7.66705 8.24076 7.4621 8.19048 7.15657 8.19048C7.00724 8.19048 6.85333 8.21257 6.69562 8.25905C6.53943 8.30705 6.40381 8.35048 6.29257 8.39314L6.44571 7.76229C6.82514 7.60762 7.18857 7.47505 7.53524 7.36533C7.88191 7.2541 8.20952 7.19924 8.5181 7.19924C9.07505 7.19924 9.50476 7.33486 9.80724 7.60305C10.1082 7.872 10.2598 8.22171 10.2598 8.65143C10.2598 8.74057 10.2491 8.89752 10.2286 9.12152C10.208 9.34629 10.1691 9.55124 10.1128 9.73943L9.536 11.7813C9.48876 11.9451 9.44686 12.1326 9.40876 12.3421C9.37143 12.5516 9.35314 12.7116 9.35314 12.819C9.35314 13.0903 9.41333 13.2754 9.53524 13.3737C9.65562 13.472 9.86667 13.5215 10.1653 13.5215C10.3063 13.5215 10.464 13.4964 10.6423 13.4476C10.819 13.3989 10.947 13.3554 11.0278 13.3181L10.8731 13.9482ZM10.771 5.66019C10.5021 5.9101 10.1783 6.03505 9.79962 6.03505C9.42171 6.03505 9.09562 5.9101 8.82438 5.66019C8.55467 5.41029 8.41829 5.10629 8.41829 4.75124C8.41829 4.39695 8.55543 4.09219 8.82438 3.84C9.09562 3.58705 9.42171 3.46133 9.79962 3.46133C10.1783 3.46133 10.5029 3.58705 10.771 3.84C11.04 4.09219 11.1749 4.39695 11.1749 4.75124C11.1749 5.10705 11.04 5.41029 10.771 5.66019Z"
      fill="#ffffff"
    />
  </svg>
);

export const SVG_ATTACH_ICON = (
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63632 0C6.54361 0 5.51636 0.425508 4.74373 1.19814C3.97104 1.97083 3.54553 2.99814 3.54548 4.09084V11.4547C3.54548 12.8081 4.64653 13.9092 6.00007 13.9092C7.3535 13.9092 8.45455 12.808 8.45455 11.4546V7.20538C8.45455 6.75352 8.08823 6.3872 7.63637 6.3872C7.18452 6.3872 6.81819 6.75352 6.81819 7.20538V11.4546C6.81819 11.9058 6.4511 12.2728 6.00007 12.2729C5.54892 12.2729 5.18183 11.9058 5.18183 11.4547V4.09084C5.18183 3.43521 5.43722 2.81879 5.9008 2.35521C6.36443 1.89158 6.98074 1.6363 7.63632 1.6363C8.9898 1.6363 10.0909 2.73736 10.091 4.09073V12.2726C10.0909 14.5284 8.25573 16.3636 6.00007 16.3636C4.90736 16.3636 3.88 15.9381 3.10737 15.1654C2.33468 14.3928 1.90917 13.3654 1.90917 12.2727L1.90906 4.09084C1.90906 3.63893 1.54274 3.27266 1.09088 3.27266C0.639031 3.27266 0.272705 3.63899 0.272705 4.09084L0.272814 12.2727C0.27276 13.8025 0.868503 15.2408 1.95024 16.3226C3.03199 17.4043 4.47024 18.0001 6.00007 18C9.15797 18 11.7272 15.4308 11.7273 12.2727V4.09079C11.7273 1.83512 9.89204 0 7.63632 0Z"
      fill="#6D7F92"
    />
  </svg>
);

export const SVG_VECTOR_ICON = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0C2.69231 0 0 2.69231 0 6C0 7.57692 0.615384 9.01748 1.61538 10.0874C1.63636 10.1154 1.66084 10.1434 1.68881 10.1643C2.77972 11.2937 4.31119 12 6 12C9.30769 12 12 9.30769 12 6C12 2.69231 9.30769 0 6 0ZM2.4965 10.0559C4.12587 9.52448 4.6993 8.87762 4.8986 8.45804C5.1993 8.59441 5.53497 8.66434 5.91259 8.67133C5.91958 8.67133 5.93007 8.67133 5.93706 8.67133H5.95105H5.96503C5.97203 8.67133 5.98252 8.67133 5.98951 8.67133C6.3951 8.66434 6.75874 8.58042 7.07692 8.42308C7.26224 8.83916 7.82168 9.51049 9.5 10.0559C8.55944 10.8671 7.33566 11.3636 5.9965 11.3636C4.66084 11.3636 3.43706 10.8706 2.4965 10.0559ZM5.96154 8.03846C5.95804 8.03846 5.95455 8.03846 5.95105 8.03846C5.94755 8.03846 5.94406 8.03846 5.94056 8.03846C5.38461 8.03147 4.96154 7.85664 4.64685 7.5C3.84965 6.6049 4.02448 4.8986 4.02448 4.88112C4.02448 4.87413 4.02448 4.86713 4.02448 4.86014C4.10839 3.00699 5.47902 2.86364 5.8986 2.86364C5.91608 2.86364 5.93357 2.86364 5.94056 2.86364C5.94755 2.86364 5.95804 2.86364 5.96503 2.86364C5.97552 2.86364 5.98951 2.86364 6.00699 2.86364C6.42308 2.86364 7.79371 3.00699 7.88112 4.86014C7.88112 4.86713 7.88112 4.87413 7.88112 4.88112C7.88461 4.8986 8.05594 6.6014 7.25874 7.5C6.94056 7.85664 6.51748 8.03147 5.96154 8.03846ZM10.014 9.55245C7.6993 8.88112 7.62238 8.05944 7.62238 8.05245C7.62238 8.06294 7.62238 8.06993 7.62238 8.06993H7.58741C7.63636 8.02448 7.68531 7.97552 7.73077 7.92308C8.68532 6.84615 8.52797 5 8.51049 4.82517C8.41958 2.90909 7.1049 2.22727 6.0035 2.22727C5.98252 2.22727 5.96154 2.22727 5.94755 2.22727C5.93357 2.22727 5.91608 2.22727 5.89161 2.22727C4.79371 2.22727 3.47902 2.90559 3.38462 4.82168C3.36713 4.99301 3.20629 6.84266 4.16434 7.91958C4.22378 7.98601 4.29021 8.04895 4.35315 8.10839C4.3007 8.28322 3.95804 8.97203 1.97902 9.54895C1.13986 8.6014 0.629371 7.36014 0.629371 5.9965C0.629371 3.03846 3.03497 0.629371 5.9965 0.629371C8.95804 0.629371 11.3636 3.03497 11.3636 5.9965C11.3671 7.36014 10.8531 8.6049 10.014 9.55245Z"
      fill="#6D7F92"
    />
  </svg>
);

export const SVG_BACK_ICON = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7069 5.19552L8.91797 2.11297C8.52724 1.8643 8.20921 2.03928 8.20921 2.50905V3.61433C4.2229 3.63584 1 6.9179 1 10.9614C1 11.6706 1.09994 12.3553 1.28473 13C2.15105 9.9451 4.92264 7.70998 8.20921 7.69155V8.79684C8.20921 9.2666 8.52724 9.44158 8.91797 9.19292L13.7069 6.11041C14.0977 5.85255 14.0977 5.44419 13.7069 5.19552Z"
      fill="#3C4E64"
    />
  </svg>
);

export const SVG_MY_MODELS_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9237 11.1115L18.1818 8.49878V5.00003C18.1818 4.87931 18.1339 4.76387 18.0487 4.67864L13.5032 0.133168C13.418 0.0479404 13.3026 0 13.1818 0H3.63635C2.63404 0 1.8182 0.815412 1.8182 1.8182V8.49878L0.0763637 11.1115C0.0266335 11.1861 0 11.274 0 11.3637V18.1818C0 19.1846 0.815881 20 1.8182 20H18.1818C19.1842 20 20 19.1846 20 18.1818V11.3637C20 11.274 19.9734 11.1861 19.9237 11.1115ZM18.1818 10.1376L18.6961 10.9091H18.1818V10.1376ZM13.6364 1.55186L16.63 4.54547H14.5454C14.0438 4.54547 13.6364 4.13753 13.6364 3.63639V1.55186ZM2.72727 1.8182C2.72727 1.31706 3.13479 0.90912 3.63635 0.90912H12.7273V3.63639C12.7273 4.63914 13.5431 5.45459 14.5454 5.45459H17.2727V10.9091H16.3636C15.3613 10.9091 14.5454 11.7246 14.5454 12.7273C14.5454 13.2285 14.1379 13.6364 13.6364 13.6364H6.36363C5.86202 13.6364 5.45455 13.2284 5.45455 12.7273C5.45455 11.7245 4.63867 10.9091 3.63635 10.9091H2.72727V1.8182ZM1.8182 10.1376V10.9091H1.30389L1.8182 10.1376ZM19.0909 18.1818C19.0909 18.683 18.6834 19.0909 18.1818 19.0909H1.8182C1.31659 19.0909 0.90912 18.683 0.90912 18.1818V11.8182H3.63639C4.138 11.8182 4.54547 12.2261 4.54547 12.7273C4.54547 13.73 5.36135 14.5454 6.36367 14.5454H13.6364C14.6387 14.5454 15.4546 13.73 15.4546 12.7273C15.4546 12.2261 15.8621 11.8182 16.3636 11.8182H19.0909V18.1818Z"
      fill="#29394D"
    />
  </svg>
);

export const SVG_LIBRARY_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2539 1.85547H1.67578C1 1.85547 0.449219 2.40625 0.449219 3.08203V12.8477C0.449219 13.5234 1 14.0742 1.67578 14.0742H14.2578C14.9336 14.0742 15.4844 13.5234 15.4844 12.8477V3.08203C15.4805 2.40625 14.9336 1.85547 14.2539 1.85547ZM1.67578 2.8125H14.2578C14.4062 2.8125 14.5273 2.93359 14.5273 3.08203V4.67188H1.40625V3.08203C1.40625 2.93359 1.52734 2.8125 1.67578 2.8125ZM14.2539 13.1172H1.67578C1.52734 13.1172 1.40625 12.9961 1.40625 12.8477V5.62891H14.5273V12.8477C14.5234 12.9961 14.4023 13.1172 14.2539 13.1172Z"
      fill="#29394D"
    />
    <path
      d="M17.5508 14.9141V5.14844C17.5508 4.88281 17.3359 4.66797 17.0703 4.66797C16.8047 4.66797 16.5898 4.88281 16.5898 5.14844V14.9141C16.5898 15.0625 16.4687 15.1836 16.3203 15.1836H3.74219C3.47656 15.1836 3.26172 15.3984 3.26172 15.6641C3.26172 15.9297 3.47656 16.1445 3.74219 16.1445H16.3242C17 16.1406 17.5508 15.5898 17.5508 14.9141Z"
      fill="#29394D"
    />
    <path
      d="M19.5508 16.9185V7.15283C19.5508 6.88721 19.3359 6.67236 19.0703 6.67236C18.8047 6.67236 18.5898 6.88721 18.5898 7.15283V16.9185C18.5898 17.0669 18.4687 17.188 18.3203 17.188H5.74609C5.48047 17.188 5.26562 17.4028 5.26562 17.6685C5.26562 17.9341 5.48047 18.1489 5.74609 18.1489H18.3281C19 18.145 19.5508 17.5942 19.5508 16.9185Z"
      fill="#29394D"
    />
    <path
      d="M5.52344 4.22266C5.64844 4.22266 5.77344 4.17188 5.85937 4.08203C5.94922 3.99219 6 3.87109 6 3.74609C6 3.62109 5.94922 3.49609 5.85937 3.40625C5.67969 3.22656 5.36328 3.22656 5.18359 3.40625C5.09375 3.49609 5.04297 3.61719 5.04297 3.74609C5.04297 3.87109 5.09375 3.99609 5.18359 4.08203C5.27344 4.17188 5.39844 4.22266 5.52344 4.22266Z"
      fill="#29394D"
    />
    <path
      d="M4.11719 4.22266C4.24219 4.22266 4.36719 4.17188 4.45703 4.08203C4.54687 3.99219 4.59766 3.87109 4.59766 3.74609C4.59766 3.62109 4.54687 3.49609 4.45703 3.40625C4.27734 3.22656 3.95703 3.22656 3.78125 3.40625C3.69141 3.49609 3.64062 3.61719 3.64062 3.74609C3.64062 3.87109 3.69141 3.99609 3.78125 4.08203C3.86719 4.17188 3.98828 4.22266 4.11719 4.22266Z"
      fill="#29394D"
    />
    <path
      d="M2.71094 4.22266C2.83594 4.22266 2.96094 4.17188 3.04687 4.08203C3.13672 3.99219 3.1875 3.87109 3.1875 3.74609C3.1875 3.62109 3.13672 3.49609 3.04687 3.40625C2.87109 3.22656 2.55078 3.22656 2.37109 3.40625C2.28125 3.49609 2.23047 3.61719 2.23047 3.74609C2.23047 3.87109 2.28125 3.99609 2.37109 4.08203C2.46094 4.17188 2.58203 4.22266 2.71094 4.22266Z"
      fill="#29394D"
    />
  </svg>
);

export const SVG_EYE = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.42716 8C1.50002 8.12591 1.59662 8.28637 1.71628 8.47165C2.02362 8.94754 2.47878 9.5804 3.06969 10.2107C4.26368 11.4843 5.933 12.6667 8 12.6667C10.067 12.6667 11.7363 11.4843 12.9303 10.2107C13.5212 9.5804 13.9764 8.94754 14.2837 8.47165C14.4034 8.28637 14.5 8.12591 14.5728 8C14.5 7.87409 14.4034 7.71363 14.2837 7.52835C13.9764 7.05246 13.5212 6.4196 12.9303 5.78929C11.7363 4.51571 10.067 3.33333 8 3.33333C5.933 3.33333 4.26368 4.51571 3.06969 5.78929C2.47878 6.4196 2.02362 7.05246 1.71628 7.52835C1.59662 7.71363 1.50002 7.87409 1.42716 8ZM15.3333 8C15.9296 7.70186 15.9295 7.70163 15.9294 7.70139L15.9283 7.69925L15.926 7.69469L15.9184 7.67988C15.9121 7.66752 15.9031 7.65021 15.8915 7.62829C15.8683 7.58447 15.8347 7.52215 15.7907 7.44399C15.7028 7.28776 15.5734 7.06768 15.4038 6.80498C15.0653 6.28088 14.5621 5.5804 13.903 4.87737C12.597 3.48429 10.5997 2 8 2C5.40033 2 3.40299 3.48429 2.09698 4.87737C1.43789 5.5804 0.93471 6.28088 0.596224 6.80498C0.426567 7.06768 0.297195 7.28776 0.209314 7.44399C0.165349 7.52215 0.131693 7.58447 0.108502 7.62829C0.0969045 7.65021 0.0879168 7.66752 0.0815586 7.67988L0.0739933 7.69469L0.0716926 7.69925L0.0709134 7.7008C0.0707909 7.70104 0.0703819 7.70186 0.666667 8L0.0703819 7.70186C-0.0234606 7.88954 -0.0234606 8.11046 0.0703819 8.29814L0.666667 8C0.0703819 8.29814 0.0702594 8.2979 0.0703819 8.29814L0.0716926 8.30075L0.0739933 8.30531L0.0815586 8.32012C0.0879168 8.33248 0.0969045 8.34979 0.108502 8.37171C0.131693 8.41553 0.165349 8.47785 0.209314 8.55601C0.297195 8.71224 0.426567 8.93232 0.596224 9.19502C0.93471 9.71913 1.43789 10.4196 2.09698 11.1226C3.40299 12.5157 5.40033 14 8 14C10.5997 14 12.597 12.5157 13.903 11.1226C14.5621 10.4196 15.0653 9.71913 15.4038 9.19502C15.5734 8.93232 15.7028 8.71224 15.7907 8.55601C15.8347 8.47785 15.8683 8.41553 15.8915 8.37171C15.9031 8.34979 15.9121 8.33248 15.9184 8.32012L15.926 8.30531L15.9283 8.30075L15.9291 8.2992C15.9292 8.29896 15.9296 8.29814 15.3333 8ZM15.3333 8L15.9296 8.29814C16.0235 8.11046 16.0232 7.88907 15.9294 7.70139L15.3333 8Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9987 6.66634C7.26232 6.66634 6.66536 7.26329 6.66536 7.99967C6.66536 8.73605 7.26232 9.33301 7.9987 9.33301C8.73508 9.33301 9.33203 8.73605 9.33203 7.99967C9.33203 7.26329 8.73508 6.66634 7.9987 6.66634ZM5.33203 7.99967C5.33203 6.52692 6.52594 5.33301 7.9987 5.33301C9.47146 5.33301 10.6654 6.52692 10.6654 7.99967C10.6654 9.47243 9.47146 10.6663 7.9987 10.6663C6.52594 10.6663 5.33203 9.47243 5.33203 7.99967Z"
      fill="white"
    />
  </svg>
);

export const SVG_EYE_OF = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0488 3.33357L13.8351 9.12511C14.1021 8.76416 14.3482 8.38801 14.572 7.99853C14.4992 7.87284 14.4029 7.71292 14.2837 7.52837C13.9764 7.05247 13.5212 6.41962 12.9303 5.78931C11.7457 4.52576 10.0933 3.35199 8.0488 3.33357ZM15.3333 8.00002L15.9296 7.70187C16.0263 7.89528 16.0232 8.12359 15.9213 8.31429C15.4947 9.11228 14.986 9.86356 14.4034 10.5559C14.2832 10.6988 14.1084 10.7848 13.9218 10.7927C13.7352 10.8007 13.5537 10.73 13.4217 10.5979L6.12838 3.29787C5.95739 3.12673 5.89254 2.87639 5.95892 2.64375C6.0253 2.41112 6.2125 2.2327 6.44806 2.17756C6.957 2.05843 7.47807 1.99885 8.00077 2.00002C8.00104 2.00002 8.0013 2.00002 8.00157 2.00002L8 2.66668V2.00002C8.00026 2.00002 8.00051 2.00002 8.00077 2.00002C10.6001 2.00031 12.5971 3.48445 13.903 4.87739C14.5621 5.58041 15.0653 6.28089 15.4038 6.805C15.5734 7.06769 15.7028 7.28778 15.7907 7.44401C15.8347 7.52217 15.8683 7.58448 15.8915 7.62831C15.9031 7.65022 15.9121 7.66753 15.9184 7.6799L15.926 7.69471L15.9283 7.69926L15.9296 7.70187C15.9297 7.70212 15.9296 7.70187 15.3333 8.00002ZM3.6354 3.51016C3.90082 3.30748 4.27526 3.33247 4.5114 3.56861L7.05545 6.11266C7.057 6.1142 7.05855 6.11574 7.06009 6.1173L9.88269 8.93989C9.88426 8.94145 9.88583 8.94302 9.88739 8.94459L12.4314 11.4886C12.5674 11.6246 12.6381 11.8128 12.6252 12.0047C12.6123 12.1966 12.5171 12.3736 12.3641 12.4902C11.1114 13.4451 9.58591 13.9742 8.0109 13.9999L8 14C5.40033 14 3.40299 12.5157 2.09698 11.1226C1.43789 10.4196 0.93471 9.71914 0.596224 9.19503C0.426567 8.93234 0.297195 8.71225 0.209314 8.55602C0.165349 8.47786 0.131693 8.41555 0.108502 8.37172C0.0969045 8.34981 0.0879168 8.3325 0.0815587 8.32013L0.0739934 8.30532L0.0716927 8.30077L0.0709135 8.29922C0.0707909 8.29897 0.070382 8.29816 0.666667 8.00002L0.0703819 8.29816C-0.0264925 8.10441 -0.023193 7.87567 0.0792296 7.6848C0.953436 6.05563 2.16594 4.63226 3.6354 3.51016ZM1.42838 8.00212C1.5011 8.12771 1.59728 8.28742 1.71628 8.47167C2.02362 8.94756 2.47878 9.58041 3.06969 10.2107C4.26263 11.4832 5.93008 12.6646 7.99456 12.6667C9.02487 12.6489 10.0291 12.3683 10.9143 11.8571L9.3665 10.3093C9.26066 10.3757 9.15005 10.4346 9.03543 10.4857C8.70832 10.6315 8.35521 10.7098 7.99715 10.7162C7.6391 10.7225 7.28344 10.6566 6.95139 10.5225C6.61935 10.3884 6.31772 10.1887 6.06449 9.93552C5.81127 9.6823 5.61165 9.38067 5.47753 9.04862C5.34341 8.71657 5.27754 8.36092 5.28386 8.00286C5.29018 7.64481 5.36855 7.29169 5.5143 6.96458C5.56537 6.84996 5.62435 6.73935 5.69069 6.63352L3.9914 4.93422C2.96688 5.80093 2.09956 6.83879 1.42838 8.00212ZM6.68526 7.62809C6.64248 7.75637 6.61938 7.89067 6.61699 8.02638C6.61383 8.20541 6.64676 8.38324 6.71382 8.54926C6.78088 8.71529 6.88069 8.8661 7.0073 8.99271C7.13391 9.11932 7.28473 9.21914 7.45075 9.2862C7.61678 9.35326 7.79461 9.38619 7.97363 9.38303C8.10935 9.38064 8.24364 9.35754 8.37193 9.31475L6.68526 7.62809Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L15.8047 14.8619C16.0651 15.1223 16.0651 15.5444 15.8047 15.8047C15.5444 16.0651 15.1223 16.0651 14.8619 15.8047L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_EBOX_SMS = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9491 2.05193C10.6271 0.7299 8.87125 0 7.00107 0C5.13089 0 3.37502 0.7299 2.053 2.05193C-0.497256 4.60218 -0.681929 8.67672 1.58985 11.438C1.27619 12.08 0.906848 12.508 0.487669 12.7131C0.232644 12.8392 0.0890088 13.1147 0.130047 13.3961C0.174017 13.6805 0.390935 13.9003 0.675273 13.9443C0.830634 13.9678 0.997719 13.9824 1.17067 13.9824C2.02954 13.9824 2.93239 13.6863 3.68574 13.1675C4.69998 13.7127 5.84027 14 7.00107 14C8.87125 14 10.6271 13.273 11.9491 11.951C13.2712 10.629 13.9981 8.87018 13.9981 7.00293C13.9981 5.13568 13.2712 3.37395 11.9491 2.05193ZM5.25151 12.9547C4.07898 14.1272 8.65727 13.2056 7.00107 13.2056C5.89303 13.2056 4.80551 12.9095 3.85869 12.3526C3.79713 12.3174 4.55151 12.2969 3.65936 12.2969C3.57435 12.2969 4.62186 11.3853 4.55151 11.438C3.65453 12.1327 4.59724 11.098 4.20151 11.1068C4.67346 10.755 2.82027 11.866 3.15151 11.1068C4.39146 10.0779 2.45459 11.224 2.35199 11.1068C0.182811 8.6562 0.297133 4.92169 2.61288 2.60595C3.78541 1.43342 0.130047 3.85 0.130048 7.35C0.675273 8.75 0.417317 9.32747 1.58985 10.5C4.01112 12.9242 2.80151 12.6 5.25151 12.9547Z"
      fill="white"
    />
    <circle cx="4" cy="7" r="1" />
    <circle cx="7" cy="7" r="1" />
    <circle cx="10" cy="7" r="1" />
  </svg>
);

export const SVG_CALENDAR_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5117 9.08594C11.9 9.08594 12.2148 8.77114 12.2148 8.38281C12.2148 7.99449 11.9 7.67969 11.5117 7.67969C11.1234 7.67969 10.8086 7.99449 10.8086 8.38281C10.8086 8.77114 11.1234 9.08594 11.5117 9.08594Z"
      fill="#18A0FB"
    />
    <path
      d="M11.5117 12.1445C11.9 12.1445 12.2148 11.8297 12.2148 11.4414C12.2148 11.0531 11.9 10.7383 11.5117 10.7383C11.1234 10.7383 10.8086 11.0531 10.8086 11.4414C10.8086 11.8297 11.1234 12.1445 11.5117 12.1445Z"
      fill="#18A0FB"
    />
    <path
      d="M14.5703 9.08594C14.9586 9.08594 15.2734 8.77114 15.2734 8.38281C15.2734 7.99449 14.9586 7.67969 14.5703 7.67969C14.182 7.67969 13.8672 7.99449 13.8672 8.38281C13.8672 8.77114 14.182 9.08594 14.5703 9.08594Z"
      fill="#18A0FB"
    />
    <path
      d="M18.2968 9.78905C18.6852 9.78905 19 9.47426 19 9.08593V5.21874C19 3.66793 17.7383 2.40625 16.1875 2.40625H15.2734V1.70312C15.2734 1.31479 14.9586 1 14.5703 1C14.182 1 13.8672 1.31479 13.8672 1.70312V2.40625H10.668V1.70312C10.668 1.31479 10.3532 1 9.96483 1C9.57649 1 9.26171 1.31479 9.26171 1.70312V2.40625H6.09765V1.70312C6.09765 1.31479 5.78286 1 5.39452 1C5.00619 1 4.6914 1.31479 4.6914 1.70312V2.40625H3.8125C2.26169 2.40625 1 3.66793 1 5.21874V16.1875C1 17.7383 2.26169 19 3.8125 19H12.6719C12.6958 19 12.7195 18.9987 12.7428 18.9964C12.7659 18.9987 12.7891 19 12.8123 19C12.9998 19 13.1838 18.9249 13.3189 18.7846L18.8033 13.0893C18.9989 12.8861 19.0543 12.5858 18.9439 12.3263C18.8335 12.0669 18.5788 11.8984 18.2968 11.8984H14.9219C13.371 11.8984 12.1094 13.1601 12.1094 14.7109V17.5937H3.8125C3.03709 17.5937 2.40625 16.9629 2.40625 16.1875V5.21874C2.40625 4.44334 3.03709 3.8125 3.8125 3.8125H4.6914V4.51562C4.6914 4.90395 5.00619 5.21874 5.39452 5.21874C5.78286 5.21874 6.09765 4.90395 6.09765 4.51562V3.8125H9.26171V4.51562C9.26171 4.90395 9.57649 5.21874 9.96483 5.21874C10.3532 5.21874 10.668 4.90395 10.668 4.51562V3.8125H13.8672V4.51562C13.8672 4.90395 14.182 5.21874 14.5703 5.21874C14.9586 5.21874 15.2734 4.90395 15.2734 4.51562V3.8125H16.1875C16.9629 3.8125 17.5937 4.44334 17.5937 5.21874V9.08593C17.5937 9.47426 17.9085 9.78905 18.2968 9.78905ZM13.5156 14.7109C13.5156 13.9355 14.1464 13.3047 14.9219 13.3047H16.6436L13.5156 16.553V14.7109Z"
      fill="#18A0FB"
    />
    <path
      d="M5.39453 9.08594C5.78285 9.08594 6.09765 8.77114 6.09765 8.38281C6.09765 7.99449 5.78285 7.67969 5.39453 7.67969C5.00621 7.67969 4.69141 7.99449 4.69141 8.38281C4.69141 8.77114 5.00621 9.08594 5.39453 9.08594Z"
      fill="#18A0FB"
    />
    <path
      d="M8.45312 12.1445C8.84145 12.1445 9.15625 11.8297 9.15625 11.4414C9.15625 11.0531 8.84145 10.7383 8.45312 10.7383C8.0648 10.7383 7.75 11.0531 7.75 11.4414C7.75 11.8297 8.0648 12.1445 8.45312 12.1445Z"
      fill="#18A0FB"
    />
    <path
      d="M5.39453 15.2031C5.78285 15.2031 6.09765 14.8883 6.09765 14.5C6.09765 14.1117 5.78285 13.7969 5.39453 13.7969C5.00621 13.7969 4.69141 14.1117 4.69141 14.5C4.69141 14.8883 5.00621 15.2031 5.39453 15.2031Z"
      fill="#18A0FB"
    />
    <path
      d="M5.39453 12.1445C5.78285 12.1445 6.09765 11.8297 6.09765 11.4414C6.09765 11.0531 5.78285 10.7383 5.39453 10.7383C5.00621 10.7383 4.69141 11.0531 4.69141 11.4414C4.69141 11.8297 5.00621 12.1445 5.39453 12.1445Z"
      fill="#18A0FB"
    />
    <path
      d="M8.45312 15.2031C8.84145 15.2031 9.15625 14.8883 9.15625 14.5C9.15625 14.1117 8.84145 13.7969 8.45312 13.7969C8.0648 13.7969 7.75 14.1117 7.75 14.5C7.75 14.8883 8.0648 15.2031 8.45312 15.2031Z"
      fill="#18A0FB"
    />
    <path
      d="M8.45312 9.08594C8.84145 9.08594 9.15625 8.77114 9.15625 8.38281C9.15625 7.99449 8.84145 7.67969 8.45312 7.67969C8.0648 7.67969 7.75 7.99449 7.75 8.38281C7.75 8.77114 8.0648 9.08594 8.45312 9.08594Z"
      fill="#18A0FB"
    />
  </svg>
);

export const SVG_DOUBLE_ARROW_RIGHT_ICON = (
  <svg
    width="18"
    height="15"
    viewBox="0 -2 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3_1204)">
      <path
        d="M14.6497 6.93827L8.35396 0.516182C8.07771 0.235003 7.63014 0.235003 7.35319 0.516182C7.07693 0.79736 7.07693 1.25407 7.35319 1.53525L13.1496 7.44777L7.35388 13.3603C7.07763 13.6415 7.07763 14.0982 7.35388 14.3801C7.63014 14.6612 8.07841 14.6612 8.35466 14.3801L14.6504 7.95798C14.9225 7.67971 14.9225 7.21583 14.6497 6.93827Z"
        fill="white"
      />
    </g>
    <g opacity="0.6">
      <g clip-path="url(#clip1_3_1204)">
        <path
          d="M7.60686 7.08476L3.1099 2.49756C2.91258 2.29671 2.59288 2.29671 2.39506 2.49756C2.19774 2.6984 2.19774 3.02462 2.39506 3.22546L6.53532 7.44869L2.39556 11.6719C2.19824 11.8728 2.19824 12.199 2.39556 12.4003C2.59288 12.6012 2.91308 12.6012 3.1104 12.4003L7.60736 7.81313C7.80169 7.61436 7.80169 7.28302 7.60686 7.08476Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3_1204">
        <rect
          width="14"
          height="14.2857"
          fill="white"
          transform="translate(4 0.305298)"
        />
      </clipPath>
      <clipPath id="clip1_3_1204">
        <rect
          width="10"
          height="10.2041"
          fill="white"
          transform="translate(0 2.34692)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_DOUBLE_ARROW_LEFT_ICON = (
  <svg
    width="18"
    height="15"
    viewBox="0 -2 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_49063_26604)">
      <path
        d="M3.35039 8.34652L9.64613 14.7686C9.92238 15.0498 10.37 15.0498 10.6469 14.7686C10.9232 14.4874 10.9232 14.0307 10.6469 13.7495L4.85054 7.83702L10.6462 1.9245C10.9225 1.64332 10.9225 1.18661 10.6462 0.904721C10.37 0.623543 9.92169 0.623543 9.64543 0.904721L3.34969 7.32681C3.07763 7.60508 3.07763 8.06896 3.35039 8.34652Z"
        fill="#6D7F92"
      />
    </g>
    <g opacity="0.6">
      <g clip-path="url(#clip1_49063_26604)">
        <path
          d="M10.3932 8.20162L14.8901 12.7888C15.0875 12.9897 15.4071 12.9897 15.605 12.7888C15.8023 12.588 15.8023 12.2618 15.605 12.0609L11.4647 7.83769L15.6045 3.61446C15.8018 3.41362 15.8018 3.0874 15.6045 2.88605C15.4071 2.6852 15.087 2.6852 14.8896 2.88605L10.3927 7.47325C10.1983 7.67201 10.1983 8.00336 10.3932 8.20162Z"
          fill="#6D7F92"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_49063_26604">
        <rect
          width="14"
          height="14.2857"
          fill="white"
          transform="translate(14 14.9795) rotate(-180)"
        />
      </clipPath>
      <clipPath id="clip1_49063_26604">
        <rect
          width="10"
          height="10.2041"
          fill="white"
          transform="translate(18 12.9395) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const SVG_SEND_COMPANION_ICON = (
  <svg
    width="20"
    height="20"
    viewBox="0 -3 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_49073_25709)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.9227 1.07709C19.2482 1.40252 19.2482 1.93016 18.9227 2.2556L9.75608 11.4223C9.43065 11.7477 8.90301 11.7477 8.57757 11.4223C8.25214 11.0968 8.25214 10.5692 8.57757 10.2437L17.7442 1.07709C18.0697 0.751649 18.5973 0.751649 18.9227 1.07709Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.9228 1.07711C19.1491 1.30347 19.2258 1.6395 19.1201 1.94166L13.2867 18.6083C13.1738 18.9308 12.8755 19.1517 12.5341 19.1657C12.1927 19.1796 11.8774 18.9837 11.7387 18.6715L8.5355 11.4644L1.32838 8.26121C1.01615 8.12244 0.820265 7.80713 0.834193 7.46573C0.848121 7.12433 1.06904 6.82602 1.39154 6.71315L18.0582 0.879816C18.3604 0.774061 18.6964 0.850744 18.9228 1.07711ZM3.92606 7.59187L9.50528 10.0715C9.69381 10.1553 9.84455 10.3061 9.92834 10.4946L12.408 16.0738L16.9752 3.02467L3.92606 7.59187Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_49073_25709">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_ROBOT_ICON = (
  <svg
    fill="#bababa"
    width="26"
    height="24"
    viewBox="-10 -130 640 640"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#bababa"
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path d="M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"></path>
    </g>
  </svg>
);

export const SVG_ALERT_CERCLE_ICON = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2_1086)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99967 1.75065C4.10018 1.75065 1.74967 4.10116 1.74967 7.00065C1.74967 9.90015 4.10018 12.2507 6.99967 12.2507C9.89917 12.2507 12.2497 9.90015 12.2497 7.00065C12.2497 4.10116 9.89917 1.75065 6.99967 1.75065ZM0.583008 7.00065C0.583008 3.45682 3.45585 0.583984 6.99967 0.583984C10.5435 0.583984 13.4163 3.45682 13.4163 7.00065C13.4163 10.5445 10.5435 13.4173 6.99967 13.4173C3.45585 13.4173 0.583008 10.5445 0.583008 7.00065Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.00033 4.08398C7.32249 4.08398 7.58366 4.34515 7.58366 4.66732V7.00065C7.58366 7.32282 7.32249 7.58398 7.00033 7.58398C6.67816 7.58398 6.41699 7.32282 6.41699 7.00065V4.66732C6.41699 4.34515 6.67816 4.08398 7.00033 4.08398Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.41699 9.33333C6.41699 9.01117 6.67816 8.75 7.00033 8.75H7.00616C7.32832 8.75 7.58949 9.01117 7.58949 9.33333C7.58949 9.6555 7.32832 9.91667 7.00616 9.91667H7.00033C6.67816 9.91667 6.41699 9.6555 6.41699 9.33333Z"
        fill="#6D7F92"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_1086">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_SIMPLE_CHECK_ICON = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.53854 12C4.16551 12 3.81271 11.8255 3.58591 11.5262L0.522827 7.48101C0.124427 6.9549 0.228142 6.20575 0.754256 5.80718C1.28123 5.40844 2.02986 5.51284 2.42843 6.03861L4.44306 8.69884L9.50997 0.563181C9.85883 0.00346685 10.5955 -0.16779 11.1564 0.180553C11.7166 0.529238 11.8877 1.26638 11.5387 1.82661L5.55306 11.4369C5.34511 11.771 4.98614 11.9812 4.59306 11.999C4.57471 11.9997 4.55671 12 4.53854 12Z"
      fill="white"
    />
  </svg>
);

export const SVG_SAVE_ICON = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83301 4.66732C5.52359 4.66732 5.22684 4.79023 5.00805 5.00903C4.78926 5.22782 4.66634 5.52456 4.66634 5.83398V22.1673C4.66634 22.4767 4.78926 22.7735 5.00805 22.9923C5.22684 23.2111 5.52359 23.334 5.83301 23.334H22.1663C22.4758 23.334 22.7725 23.2111 22.9913 22.9923C23.2101 22.7735 23.333 22.4767 23.333 22.1673V9.81723L18.1831 4.66732H5.83301ZM3.35813 3.35911C4.01451 2.70273 4.90475 2.33398 5.83301 2.33398H18.6663C18.9758 2.33398 19.2725 2.4569 19.4913 2.67569L25.3246 8.50903C25.5434 8.72782 25.6663 9.02457 25.6663 9.33398V22.1673C25.6663 23.0956 25.2976 23.9858 24.6412 24.6422C23.9848 25.2986 23.0946 25.6673 22.1663 25.6673H5.83301C4.90475 25.6673 4.01451 25.2986 3.35813 24.6422C2.70176 23.9858 2.33301 23.0956 2.33301 22.1673V5.83398C2.33301 4.90573 2.70176 4.01549 3.35813 3.35911Z"
      fill="#06D9B1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 15.1667C7 14.5223 7.52233 14 8.16667 14H19.8333C20.4777 14 21 14.5223 21 15.1667V24.5C21 25.1443 20.4777 25.6667 19.8333 25.6667C19.189 25.6667 18.6667 25.1443 18.6667 24.5V16.3333H9.33333V24.5C9.33333 25.1443 8.811 25.6667 8.16667 25.6667C7.52233 25.6667 7 25.1443 7 24.5V15.1667Z"
      fill="#06D9B1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.16667 2.33398C8.811 2.33398 9.33333 2.85632 9.33333 3.50065V8.16732H17.5C18.1443 8.16732 18.6667 8.68965 18.6667 9.33398C18.6667 9.97832 18.1443 10.5007 17.5 10.5007H8.16667C7.52233 10.5007 7 9.97832 7 9.33398V3.50065C7 2.85632 7.52233 2.33398 8.16667 2.33398Z"
      fill="#06D9B1"
    />
  </svg>
);

export const SVG_ALERT_TRIANGLE_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.71758 2.89589L1.36508 13.5009C1.2341 13.7277 1.1648 13.9849 1.16407 14.2468C1.16334 14.5087 1.23119 14.7662 1.3609 14.9938C1.4906 15.2213 1.67762 15.4109 1.90336 15.5438C2.12909 15.6766 2.38568 15.748 2.64758 15.7509H15.3526C15.6145 15.748 15.8711 15.6766 16.0968 15.5438C16.3225 15.4109 16.5096 15.2213 16.6393 14.9938C16.769 14.7662 16.8368 14.5087 16.8361 14.2468C16.8354 13.9849 16.7661 13.7277 16.6351 13.5009L10.2826 2.89589C10.1489 2.67547 9.96062 2.49323 9.73597 2.36675C9.51133 2.24027 9.25788 2.17383 9.00008 2.17383C8.74228 2.17383 8.48882 2.24027 8.26418 2.36675C8.03954 2.49323 7.85128 2.67547 7.71758 2.89589Z"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 6.75V9.75"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 12.75H9.0075"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const SVG_CHECK_APPROVER_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5791 3.0876C12.807 3.31541 12.807 3.68475 12.5791 3.91256L6.16248 10.3292C5.93467 10.557 5.56533 10.557 5.33752 10.3292L2.42085 7.41256C2.19305 7.18475 2.19305 6.81541 2.42085 6.5876C2.64866 6.3598 3.01801 6.3598 3.24581 6.5876L5.75 9.09179L11.7542 3.0876C11.982 2.8598 12.3513 2.8598 12.5791 3.0876Z"
      fill="#02AF8E"
    />
  </svg>
);
export const SVG_CLOCK_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clip-path="url(#clip0_762_4167)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.00016 1.74992C4.10067 1.74992 1.75016 4.10042 1.75016 6.99992C1.75016 9.89941 4.10067 12.2499 7.00016 12.2499C9.89966 12.2499 12.2502 9.89941 12.2502 6.99992C12.2502 4.10042 9.89966 1.74992 7.00016 1.74992ZM0.583496 6.99992C0.583496 3.45609 3.45634 0.583252 7.00016 0.583252C10.544 0.583252 13.4168 3.45609 13.4168 6.99992C13.4168 10.5437 10.544 13.4166 7.00016 13.4166C3.45634 13.4166 0.583496 10.5437 0.583496 6.99992Z"
        fill="#D87318"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99984 2.91675C7.322 2.91675 7.58317 3.17792 7.58317 3.50008V6.63956L9.59405 7.645C9.8822 7.78908 9.999 8.13947 9.85492 8.42762C9.71084 8.71578 9.36045 8.83257 9.0723 8.6885L6.73896 7.52183C6.54134 7.42302 6.4165 7.22103 6.4165 7.00008V3.50008C6.4165 3.17792 6.67767 2.91675 6.99984 2.91675Z"
        fill="#D87318"
      />
    </g>
    <defs>
      <clipPath id="clip0_762_4167">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SVG_REJECT_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M7.71758 2.89589L1.36508 13.5009C1.2341 13.7277 1.1648 13.9849 1.16407 14.2468C1.16334 14.5087 1.23119 14.7662 1.3609 14.9938C1.4906 15.2213 1.67762 15.4109 1.90336 15.5438C2.12909 15.6766 2.38568 15.748 2.64758 15.7509H15.3526C15.6145 15.748 15.8711 15.6766 16.0968 15.5438C16.3225 15.4109 16.5096 15.2213 16.6393 14.9938C16.769 14.7662 16.8368 14.5087 16.8361 14.2468C16.8354 13.9849 16.7661 13.7277 16.6351 13.5009L10.2826 2.89589C10.1489 2.67547 9.96062 2.49323 9.73597 2.36675C9.51133 2.24027 9.25788 2.17383 9.00008 2.17383C8.74228 2.17383 8.48882 2.24027 8.26418 2.36675C8.03954 2.49323 7.85128 2.67547 7.71758 2.89589Z"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 6.75V9.75"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 12.75H9.0075"
      stroke="#EB5757"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SVG_FLAG_ICON = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 10C2.66699 10 3.33366 9.33334 5.33366 9.33334C7.33366 9.33334 8.66699 10.6667 10.667 10.6667C12.667 10.6667 13.3337 10 13.3337 10V2.00001C13.3337 2.00001 12.667 2.66668 10.667 2.66668C8.66699 2.66668 7.33366 1.33334 5.33366 1.33334C3.33366 1.33334 2.66699 2.00001 2.66699 2.00001V10Z"
      stroke="#18A0FB"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.66699 14.6667V10"
      stroke="#18A0FB"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SVG_MAIL_PLUS = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.99984 2.33331C7.322 2.33331 7.58317 2.59448 7.58317 2.91665V11.0833C7.58317 11.4055 7.322 11.6666 6.99984 11.6666C6.67767 11.6666 6.4165 11.4055 6.4165 11.0833V2.91665C6.4165 2.59448 6.67767 2.33331 6.99984 2.33331Z"
      fill="#29394D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.3335 7.00002C2.3335 6.67785 2.59466 6.41669 2.91683 6.41669H11.0835C11.4057 6.41669 11.6668 6.67785 11.6668 7.00002C11.6668 7.32219 11.4057 7.58335 11.0835 7.58335H2.91683C2.59466 7.58335 2.3335 7.32219 2.3335 7.00002Z"
      fill="#29394D"
    />
  </svg>
);
export const SVG_Image_UPLOAD = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="11"
    viewBox="0 0 14 11"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.46967 0.96967C8.76256 0.676777 9.23744 0.676777 9.53033 0.96967L13.2803 4.71967C13.5732 5.01256 13.5732 5.48744 13.2803 5.78033C12.9874 6.07322 12.5126 6.07322 12.2197 5.78033L9 2.56066L1.28033 10.2803C0.987437 10.5732 0.512563 10.5732 0.21967 10.2803C-0.0732233 9.98744 -0.0732233 9.51256 0.21967 9.21967L8.46967 0.96967Z"
      fill="#6D7F92"
    />
  </svg>
);
export const SVG_Image_UPLOAD_FILE = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.75 3C3.33579 3 3 3.33579 3 3.75V14.25C3 14.6642 3.33579 15 3.75 15H14.25C14.6642 15 15 14.6642 15 14.25V3.75C15 3.33579 14.6642 3 14.25 3H3.75ZM1.5 3.75C1.5 2.50736 2.50736 1.5 3.75 1.5H14.25C15.4926 1.5 16.5 2.50736 16.5 3.75V14.25C16.5 15.4926 15.4926 16.5 14.25 16.5H3.75C2.50736 16.5 1.5 15.4926 1.5 14.25V3.75Z"
      fill="#6D7F92"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.375 6C6.16789 6 6 6.16789 6 6.375C6 6.58211 6.16789 6.75 6.375 6.75C6.58211 6.75 6.75 6.58211 6.75 6.375C6.75 6.16789 6.58211 6 6.375 6ZM4.5 6.375C4.5 5.33947 5.33947 4.5 6.375 4.5C7.41053 4.5 8.25 5.33947 8.25 6.375C8.25 7.41053 7.41053 8.25 6.375 8.25C5.33947 8.25 4.5 7.41053 4.5 6.375Z"
      fill="#6D7F92"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.4697 6.96967C11.7626 6.67678 12.2374 6.67678 12.5303 6.96967L16.2803 10.7197C16.5732 11.0126 16.5732 11.4874 16.2803 11.7803C15.9874 12.0732 15.5126 12.0732 15.2197 11.7803L12 8.56066L4.28033 16.2803C3.98744 16.5732 3.51256 16.5732 3.21967 16.2803C2.92678 15.9874 2.92678 15.5126 3.21967 15.2197L11.4697 6.96967Z"
      fill="#6D7F92"
    />
  </svg>
);
export const SVG_ALERT_ICON = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.89623 1.71126C8.2332 1.52154 8.61337 1.42188 9.00008 1.42188C9.38678 1.42188 9.76695 1.52154 10.1039 1.71126C10.4409 1.90097 10.7233 2.17433 10.9238 2.50496L10.926 2.50852L17.2785 13.1135L17.2846 13.1239C17.481 13.4641 17.585 13.8498 17.5861 14.2427C17.5872 14.6356 17.4854 15.0219 17.2908 15.3632C17.0963 15.7045 16.8158 15.989 16.4771 16.1882C16.1385 16.3875 15.7537 16.4946 15.3608 16.4989L15.3526 16.499L2.63933 16.4989C2.24648 16.4946 1.86161 16.3875 1.52301 16.1882C1.1844 15.989 0.903866 15.7045 0.709314 15.3632C0.514761 15.0219 0.412971 14.6356 0.414071 14.2427C0.415171 13.8498 0.519123 13.4641 0.715584 13.1239L0.721676 13.1135L7.07632 2.50496C7.27687 2.17433 7.55926 1.90097 7.89623 1.71126ZM9.00008 2.92188C8.87118 2.92188 8.74445 2.9551 8.63213 3.01834C8.52031 3.08129 8.42653 3.17187 8.35973 3.28141L2.01209 13.8783C1.94821 13.9907 1.91443 14.1176 1.91407 14.2469C1.9137 14.3779 1.94763 14.5067 2.01248 14.6204C2.07733 14.7342 2.17084 14.829 2.28371 14.8954C2.39559 14.9613 2.52262 14.9969 2.65237 14.9989H15.3478C15.4775 14.9969 15.6046 14.9613 15.7164 14.8954C15.8293 14.829 15.9228 14.7342 15.9877 14.6204C16.0525 14.5067 16.0865 14.3779 16.0861 14.2469C16.0857 14.1176 16.052 13.9907 15.9881 13.8783L9.64133 3.2829C9.64102 3.28241 9.64072 3.28191 9.64042 3.28141C9.57362 3.17187 9.47984 3.08129 9.36802 3.01834C9.2557 2.9551 9.12898 2.92188 9.00008 2.92188Z"
      fill="#EA8124"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 6C9.41421 6 9.75 6.33579 9.75 6.75V9.75C9.75 10.1642 9.41421 10.5 9 10.5C8.58579 10.5 8.25 10.1642 8.25 9.75V6.75C8.25 6.33579 8.58579 6 9 6Z"
      fill="#EA8124"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.25 12.75C8.25 12.3358 8.58579 12 9 12H9.0075C9.42171 12 9.7575 12.3358 9.7575 12.75C9.7575 13.1642 9.42171 13.5 9.0075 13.5H9C8.58579 13.5 8.25 13.1642 8.25 12.75Z"
      fill="#EA8124"
    />
  </svg>
);
